<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="dashboard-bd">
    <div class="dashboard-header">
      <div class="title">
        <h3>
          {{ userInfo.realName }},
          <span>{{ timeDay }}</span>
        </h3>
        <p class="time">{{ $t('base_dashboard.jtsoohyhdiynergyglpt', [today,weekday]) }}</p>
      </div>
      <div class="tabs">
        <el-form :inline="true" @submit.native.prevent class="filter-form">
          <el-radio-group v-model="formSearch.dataType" @change="onTypeChange()">
            <el-radio-button :label="item.value" v-for="(item, index) in dataTypeData" :key="index">{{ item.label }}</el-radio-button>
          </el-radio-group>
          <div class="filter-values">
            <div class="label">{{ $t('base_dashboard.shai_xuan_xiang') }}：</div>
            <div class="values">
              <el-tag closable v-for="(productTag, index) in formSearch.productCode" :key="productTag" @close="clearTag('productCode', index)">{{ productTag }}</el-tag>
              <el-tag
                v-if="formSearch.customerId"
                closable
                @close="
                  formSearch.customerName = '';
                  formSearch.customerId = '';
                  onTypeChange();
                "
              >
                {{ formSearch.customerName }}
              </el-tag>
              <el-tag
                v-if="formSearch.agentCoId"
                closable
                @close="
                  formSearch.agentCoName = '';
                  formSearch.agentCoId = '';
                  onTypeChange();
                "
              >
                {{ formSearch.agentCoName }}
              </el-tag>
              <el-tag
                v-if="formSearch.afterServiceId"
                closable
                @close="
                  formSearch.afterServiceName = '';
                  formSearch.afterServiceId = '';
                  onTypeChange();
                "
              >
                {{ formSearch.afterServiceName }}
              </el-tag>
              <el-tag
                v-if="formSearch.locationId"
                closable
                @close="
                  formSearch.locationName = '';
                  formSearch.locationId = '';
                  onTypeChange();
                "
              >
                {{ formSearch.locationName }}
              </el-tag>
              <span class="clear" @click="onClear">{{ $t('Common.com_clear') }}</span>
            </div>
          </div>
          <div class="filter-btn">
            <i class="icon icon-shiliang" @click="onFilter"></i>
          </div>
        </el-form>
      </div>
      <img class="bg-img" src="~@/images/layout/portal_bg.png" alt="" />
    </div>
    <div class="dashboard-wrap">
      <div class="dashboard-wrap-left">
        <div class="card card-device" v-if="funcView.dashboard_realtime_status || funcView.dashboard_business_status || (productCountList.length && funcView.dashboard_business_status_product)">
          <div class="pie" v-if="funcView.dashboard_realtime_status || funcView.dashboard_business_status">
            <div class="pie-item">
              <div class="pie-chart-left" v-if="funcView.dashboard_realtime_status">
                <p class="title">{{ $t('base_dashboard.ji_qi_shi_shi') }}</p>
                <div class="chart-pie">
                  <my-pie @click="jump('/redirect/device/mydevice', null, null, true)" :pieData="deviceStatusCount.stateList" :score="`${deviceStatusCount.total}`"></my-pie>
                </div>
                <!-- <div  id="chart" style="width: 100px;height:100px;"></div> -->
                <ul class="chart-info">
                  <li class="chart-info-item">
                    <i style="background: #93da49"></i>
                    <p class="line" @click="onDeviceStatusCount({ machineState: [2, 3, 4], isCharging: [0], isOnline: [1] })">
                      <span class="name">{{ $t('base_dashboard.qing_jie') }}</span>
                      <span class="num">{{ deviceStatusCount.using }}</span>
                    </p>
                  </li>
                  <li class="chart-info-item">
                    <i style="background: #00a0d9"></i>
                    <p class="line" @click="onDeviceStatusCount({ machineState: [1, 5, 6, 9], isCharging: [0], isOnline: [1] })">
                      <span class="name">{{ $t('base_dashboard.kong_xian') }}</span>
                      <span class="num">{{ deviceStatusCount.idle }}</span>
                    </p>
                  </li>
                  <li class="chart-info-item">
                    <i style="background: #ffad00"></i>
                    <p class="line" @click="onDeviceStatusCount({ isCharging: [1] })">
                      <span class="name">{{ $t('base_dashboard.chong_dian') }}</span>
                      <span class="num">{{ deviceStatusCount.charging }}</span>
                    </p>
                  </li>
                  <li class="chart-info-item">
                    <i style="background: #b3b3b3"></i>
                    <p class="line" @click="onDeviceStatusCount({ isOnline: [0] })">
                      <span class="name">{{ $t('base_dashboard.li_xian') }}</span>
                      <span class="num">{{ deviceStatusCount.offline }}</span>
                    </p>
                  </li>
                </ul>
                <ul
                  class="chart-status"
                  v-if="
                    funcView.dashboard_realtime_status_lock ||
                    funcView.dashboard_realtime_status_fault ||
                    funcView.dashboard_realtime_status_energy ||
                    funcView.dashboard_realtime_status_machine_not_activated ||
                    funcView.dashboard_realtime_status_sim_not_activated ||
                    funcView.dashboard_realtime_status_lock_work
                  "
                >
                  <li class="chart-info-item" v-if="funcView.dashboard_realtime_status_lock">
                    <p class="line" @click="onDeviceStatusCount({ lockState: [1] })">
                      <span class="name">{{ $t('base_dashboard.suo_ji') }}</span>
                      <span class="num">{{ deviceStatusCount.locked }}</span>
                    </p>
                  </li>
                  <li class="chart-info-item" v-if="funcView.dashboard_realtime_status_fault">
                    <p class="line" @click="onDeviceStatusCount({ isMalfunction: [1] })">
                      <span class="name">{{ $t('base_dashboard.gu_zhang') }}</span>
                      <span class="num">{{ deviceStatusCount.malfunction }}</span>
                    </p>
                  </li>
                  <li class="chart-info-item" v-if="funcView.dashboard_realtime_status_energy">
                    <p class="line" @click="onDeviceStatusCount({ isPowerSave: [1] })">
                      <span class="name">{{ $t('base_dashboard.jie_neng') }}</span>
                      <span class="num">{{ deviceStatusCount.powerSave }}</span>
                    </p>
                  </li>
                  <li class="chart-info-item" v-if="funcView.dashboard_realtime_status_machine_not_activated">
                    <p class="line" @click="onDeviceStatusCount({ activateState: [0] })">
                      <span class="name">{{ $t('base_dashboard.wei_ji_huo') }}</span>
                      <span class="num">{{ deviceStatusCount.deactivated }}</span>
                    </p>
                  </li>
                  <li class="chart-info-item" v-if="funcView.dashboard_realtime_status_sim_not_activated">
                    <p class="line" @click="onDeviceStatusCount({ simState: [0, 20, 50, 99] })">
                      <span class="name">{{ $t('base_dashboard.SIMwei_ji_huo') }}</span>
                      <span class="num">{{ deviceStatusCount.simDeactivated }}</span>
                    </p>
                  </li>
                  <li class="chart-info-item" v-if="funcView.dashboard_realtime_status_lock_work">
                    <p class="line" @click="onDeviceLockCount({ isLatest: [1] })">
                      <span class="name">{{ $t('base_dashboard.suo_ji_gong_zuo') }}</span>
                      <span class="num">{{ deviceStatusCount.lockClean }}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div class="pie-chart-right" v-if="funcView.dashboard_business_status">
                <p class="title">{{ $t('base_dashboard.ji_qi_ye_wu') }}</p>
                <div class="chart-pie">
                  <my-pie :pieData="deviceBizCount.stateList" :score="`${deviceStatusCount.total}`"></my-pie>
                </div>
                <ul class="chart-info">
                  <li class="chart-info-item" v-for="(item, index) in deviceBizCount.stateList" :key="index" @click="onDeviceBizCount({ bizState: item.state })">
                    <i :style="{ background: item.itemStyle.color }"></i>
                    <p class="line">
                      <span class="name">{{ item.label }}</span>
                      <span class="num">{{ item.value }}</span>
                    </p>
                  </li>
                </ul>
                <ul class="chart-status" v-if="funcView.dashboard_business_status_rate">
                  <li class="chart-info-item">
                    <p class="line line-t">
                      <span class="name">{{ $t('base_dashboard.zuo_ri_shi_yong_lv') }}</span>
                      <span class="num">{{ deviceBizCount.yesterdayCleanRate || '-' }}%</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="device" v-if="productCountList.length && funcView.dashboard_business_status_product">
            <ul class="model-info">
              <li class="model-info-item" v-for="(item, index) in productCountList" :key="index" @click="toggleSelection(item.productCode)" :class="{ selected: isSelected(item.productCode) }">
                <i class="num">{{ item.deviceNum }}</i>
                <img class="img" :src="item.attachPath" alt="" />
                <p class="model">{{ item.productCode }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="card card-order"
          v-if="funcView.dashboard_business_status_fault || funcView.dashboard_firmware_version || funcView.dashboard_work_order_pending || funcView.dashboard_work_order_processing"
        >
          <div class="pie" v-if="funcView.dashboard_business_status_fault || funcView.dashboard_firmware_version">
            <div class="pie-item">
              <div class="pie-chart-left pie-ovh" v-if="funcView.dashboard_business_status_fault">
                <p class="title">{{ $t('base_dashboard.xing_hao_gu_zhang') }}</p>
                <div class="chart-pie">
                  <my-pie :pieData="faultProductCount.detailList" :score="`${faultProductCount.total}`"></my-pie>
                </div>
                <!-- <div  id="chart" style="width: 100px;height:100px;"></div> -->
                <ul class="chart-info chart-info-ovh">
                  <li
                    class="chart-info-item"
                    v-for="(item, index) in faultProductCount.detailList"
                    :key="index"
                    @click="onDeviceStatusCount({ isMalfunction: [1], formSearch: { productCode: item.productCode } })"
                  >
                    <i :style="{ background: item.itemStyle.color }"></i>
                    <p class="line">
                      <span class="name">{{ item.productCode }}</span>
                      <span class="num">{{ item.malfunction }}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div class="pie-chart-right pie-ovh" v-if="funcView.dashboard_firmware_version">
                <div class="flex-box">
                  <p class="title">{{ $t('base_dashboard.gu_jian_ban_ben') }}</p>
                  <div class="chart-select">
                    <custom-select
                      type="tree"
                      url="adminPortalProductComponent"
                      v-model="formSearch.componentCodeVersion"
                      :props="{ label: 'name', value: 'value' }"
                      :dataFilter="componentFilter"
                      :placeholder="$t('base_dashboard.xing_hao_bu_jian')"
                      width="170px"
                      style="margin-left: 24px"
                      @treeValChange="getProductComponentVersionCount()"
                    ></custom-select>
                  </div>
                </div>
                <div class="chart-pie">
                  <my-pie :pieData="productComponentVersionCount.versionList" :score="`${productComponentVersionCount.total}`"></my-pie>
                </div>
                <ul class="chart-info chart-info-ovh" v-if="productComponentVersionCount.versionList.length">
                  <li class="chart-info-item" v-for="(item, index) in productComponentVersionCount.versionList" :key="index" @click="onFwVersion(item.fwVersion)">
                    <i :style="{ background: item.itemStyle.color }"></i>
                    <p class="line">
                      <span class="name">{{ item.fwVersion }}</span>
                      <span class="num">{{ item.num }}</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="pie" v-if="funcView.dashboard_work_order_pending || funcView.dashboard_work_order_processing">
            <div class="pie-item">
              <div class="pie-chart-left" v-if="funcView.dashboard_work_order_pending">
                <div class="flex-box">
                  <p class="title">{{ $t('base_dashboard.gong_dan_dai_jie_dan') }}</p>
                  <div class="chart-select" v-if="funcView.dashboard_work_order_pending_filter">
                    <custom-select
                      :data="workOrganTypeData"
                      :auto="false"
                      v-model="formSearch.workOrganType"
                      width="90px"
                      class="select-box"
                      :props="{ label: 'label', value: 'value' }"
                      @change="getworkOrderStatistics()"
                      :clearable="false"
                    ></custom-select>
                  </div>
                </div>
                <div class="chart-pie">
                  <my-pie :pieData="workOrderCount.wait.stateList" :score="`${workOrderCount.wait.total}`"></my-pie>
                </div>
                <ul class="chart-info chart-info-ovh">
                  <li class="chart-info-item" v-for="(item, index) in workOrderCount.wait.stateList" :key="index" @click="onWorkOrderCount({ curTable: 'wait', workOrderType: item.state })">
                    <i :style="{ background: item.itemStyle.color }"></i>
                    <p class="line">
                      <span class="name">{{ item.label }}</span>
                      <span class="num">{{ item.value }}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div class="pie-chart-right" v-if="funcView.dashboard_work_order_processing">
                <div class="flex-box">
                  <p class="title">{{ $t('base_dashboard.gdclz') }}</p>
                  <div class="chart-select" v-if="funcView.dashboard_work_order_processing_filter">
                    <custom-select
                      :data="workOrganTypeData"
                      :auto="false"
                      v-model="formSearch.workOrganType"
                      width="90px"
                      class="select-box"
                      :props="{ label: 'label', value: 'value' }"
                      @change="getworkOrderStatistics()"
                      :clearable="false"
                    ></custom-select>
                  </div>
                </div>
                <div class="chart-pie">
                  <my-pie :pieData="workOrderCount.process.stateList" :score="`${workOrderCount.process.total}`"></my-pie>
                </div>
                <ul class="chart-info">
                  <li class="chart-info-item" v-for="(item, index) in workOrderCount.process.stateList" :key="index" @click="onWorkOrderCount({ curTable: 'ing', workOrderType: item.state })">
                    <i :style="{ background: item.itemStyle.color }"></i>
                    <p class="line">
                      <span class="name">{{ item.label }}</span>
                      <span class="num">{{ item.value }}</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          class="card financial-order"
          v-if="
            funcView.dashboard_financial_invoice_receipt ||
            funcView.dashboard_financial_invoice_payment ||
            funcView.dashboard_financial_receipt_timeliness ||
            funcView.dashboard_financial_payment_timeliness
          "
        >
          <div class="pie">
            <div class="pie-item">
              <div class="pie-chart-left" v-if="funcView.dashboard_financial_invoice_receipt">
                <p class="title">{{ $t('base_dashboard.shou_kuan') }}</p>
                <div class="chart-pie">
                  <my-pie :pieData="billOrderCount.receivable.stateList" :score="`${billOrderCount.receivable.ratioAmount}`" type="ratio"></my-pie>
                </div>
                <ul class="chart-info">
                  <li class="chart-info-item" v-for="(item, index) in billOrderCount.receivable.stateList" :key="index" @click="onBillOrderCount('receivable', item.state)">
                    <i :style="{ background: item.color }"></i>
                    <p class="line">
                      <span class="name">{{ item.label }}</span>
                      <span class="num">¥{{ item.amount | formatThousandth }}</span>
                    </p>
                  </li>
                </ul>
                <ul class="chart-status">
                  <li class="chart-info-item">
                    <p class="line" @click="onBillOrderCount('receivable', 'nextMonthAmount')">
                      <span class="name">{{ $t('base_dashboard.xia_yue_ying_shou') }}</span>
                      <span class="num">¥{{ billOrderCount.receivable.nextMonthAmount | formatThousandth }}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div class="pie-chart-left" v-if="funcView.dashboard_financial_invoice_payment">
                <p class="title">{{ $t('base_dashboard.fu_kuan') }}</p>
                <div class="chart-pie">
                  <my-pie :pieData="billOrderCount.payment.stateList" :score="`${billOrderCount.payment.ratioAmount}`" type="ratio"></my-pie>
                </div>
                <ul class="chart-info">
                  <li class="chart-info-item" v-for="(item, index) in billOrderCount.payment.stateList" :key="index" @click="onBillOrderCount('payment', item.state)">
                    <i :style="{ background: item.color }"></i>
                    <p class="line">
                      <span class="name">{{ item.label }}</span>
                      <span class="num">¥{{ item.amount | formatThousandth }}</span>
                    </p>
                  </li>
                </ul>
                <ul class="chart-status">
                  <li class="chart-info-item" @click="onBillOrderCount('payment', 'nextMonthAmount')">
                    <p class="line">
                      <span class="name">{{ $t('base_dashboard.xia_yue_ying_fu') }}</span>
                      <span class="num">¥{{ billOrderCount.payment.nextMonthAmount | formatThousandth }}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div class="pie-chart-left" v-if="funcView.dashboard_financial_receipt_timeliness">
                <p class="title">{{ $t('base_dashboard.skjsl30tn') }}</p>
                <div class="chart-pie financial-chart-pie">
                  <my-pie :pieData="billOrderCount.receivable.ratioList" :score="`${billOrderCount.receivable.ratio}`" type="ratio"></my-pie>
                </div>
              </div>
              <div class="pie-chart-right" v-if="funcView.dashboard_financial_payment_timeliness">
                <p class="title">{{ $t('base_dashboard.fkjsl30tn') }}</p>
                <div class="chart-pie financial-chart-pie">
                  <my-pie :pieData="billOrderCount.payment.ratioList" :score="`${billOrderCount.payment.ratio}`" type="ratio"></my-pie>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="card count-device"
          v-if="
            funcView.dashboard_within_statistics_rented ||
            funcView.dashboard_time_within_statistics_trial ||
            funcView.dashboard_time_within_statistics_sold ||
            funcView.dashboard_time_within_statistics_expire ||
            funcView.dashboard_time_within_statistics_expiration ||
            funcView.dashboard_time_within_statistics_no_upload_chart ||
            funcView.dashboard_time_within_statistics_no_upload_map ||
            funcView.dashboard_time_within_statistics_no_upload_record ||
            funcView.dashboard_time_within_statistics_incomplete_clean ||
            funcView.dashboard_time_within_statistics_cliff ||
            funcView.dashboard_time_within_statistics_collision
          "
        >
          <div class="pie">
            <div class="header">
              <h4>{{ $t('base_dashboard.jqsjglt') }}</h4>
              <p v-if="orderHistCount.pastStartTime">{{ momentAmPm($momentLocal(orderHistCount.pastStartTime)) }} - {{ momentAmPm($momentLocal(orderHistCount.pastEndTime)) }}</p>
              <el-radio-group v-model="formSearch.withinDays" @change="onWithinDay()">
                <el-radio-button :label="item.value" v-for="(item, index) in withinDay" :key="index">{{ item.label }}</el-radio-button>
              </el-radio-group>
            </div>
            <div class="pie-row">
              <el-row :gutter="10">
                <el-col :span="4" v-if="funcView.dashboard_within_statistics_rented">
                  <div class="grid-content">
                    <h6>{{ $t('base_dashboard.zu_chu') }}</h6>
                    <p @click="onHistCountLease()">{{ orderHistCount.lease || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4" v-if="funcView.dashboard_time_within_statistics_trial">
                  <div class="grid-content">
                    <h6>{{ $t('base_dashboard.shi_yong') }}</h6>
                    <p @click="onHistCountTrial()">{{ orderHistCount.trial || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4" v-if="funcView.dashboard_time_within_statistics_sold">
                  <div class="grid-content">
                    <h6>{{ $t('base_dashboard.yi_shou') }}</h6>
                    <p @click="onHistCountSale()">{{ orderHistCount.sale || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4" v-if="funcView.dashboard_time_within_statistics_expire">
                  <div class="grid-content">
                    <h6>
                      {{ $t('base_dashboard.jiang_dao_qi') }}
                      <el-popover placement="top-start" width="320" trigger="hover" :content="`${$momentLocal(orderHistCount.futureStartTime)} - ${$momentLocal(orderHistCount.futureEndTime)}`">
                        <i class="icon icon-qingsaoshijian" slot="reference"></i>
                      </el-popover>
                    </h6>
                    <p @click="onHistCountExpiring()">{{ orderHistCount.expiring || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4" v-if="funcView.dashboard_time_within_statistics_expiration">
                  <div class="grid-content">
                    <h6>
                      {{ $t('base_dashboard.ku_cun_dao_qi') }}
                      <el-popover placement="top-start" width="320" trigger="hover" :content="`${$momentLocal(orderHistCount.futureStartTime)} - ${$momentLocal(orderHistCount.futureEndTime)}`">
                        <i class="icon icon-qingsaoshijian" slot="reference"></i>
                      </el-popover>
                    </h6>
                    <p @click="onStockExpired()">{{ orderHistCount.stockExpired || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4" v-if="funcView.dashboard_time_within_statistics_no_upload_chart">
                  <div class="grid-content">
                    <h6>{{ $t('base_dashboard.wscyxt') }}</h6>
                    <p @click="onUploadCount('unUploadUsePic', deviceHistCount, 'dashboard_unUploadUsePic')">{{ deviceHistCount.unUploadUsePic || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4" v-if="funcView.dashboard_time_within_statistics_no_upload_map">
                  <div class="grid-content">
                    <h6>{{ $t('base_dashboard.wscdt') }}</h6>
                    <p @click="onUploadCount('unUploadMap', deviceHistCount, 'dashboard_unUploadMap')">{{ deviceHistCount.unUploadMap || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4" v-if="funcView.dashboard_time_within_statistics_no_upload_record">
                  <div class="grid-content">
                    <h6>{{ $t('base_dashboard.wscqjjl') }}</h6>
                    <p @click="onUploadCount('unUploadRecord', deviceHistCount, 'dashboard_unUploadUsePic')">{{ deviceHistCount.unUploadUseRecord || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content" v-if="funcView.dashboard_time_within_statistics_incomplete_clean">
                    <h6>
                      {{ $t('base_dashboard.wwcqj') }}
                      <el-popover placement="top-start" width="200" trigger="hover" :content="$t('base_dashboard.dtcf3cys')">
                        <i class="icon icon-a-shiliang2" slot="reference"></i>
                      </el-popover>
                    </h6>
                    <p @click="onUploadCount('unComplete', deviceHistCount, 'dashboard_unCompleteRecord')">{{ deviceHistCount.unComplete || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content" v-if="funcView.dashboard_time_within_statistics_cliff">
                    <h6>
                      {{ $t('base_dashboard.xuan_ya_chu_fa') }}
                      <el-popover placement="top-start" width="120" trigger="hover" :content="$t('base_dashboard.dcqjcfcscg5c')">
                        <i class="icon icon-a-shiliang2" slot="reference"></i>
                      </el-popover>
                    </h6>
                    <p @click="onUploadCount('cliffCount', deviceHistCount, 'dashboard_unCompleteRecord')">{{ deviceHistCount.cliffCount || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content" v-if="funcView.dashboard_time_within_statistics_collision">
                    <h6>
                      {{ $t('base_dashboard.peng_zhuang_chu_fa') }}
                      <el-popover placement="top-start" width="120" trigger="hover" :content="$t('base_dashboard.dcqjcfcscg5c')">
                        <i class="icon icon-a-shiliang2" slot="reference"></i>
                      </el-popover>
                    </h6>
                    <p @click="onUploadCount('bumpCount', deviceHistCount, 'dashboard_unCompleteRecord')">{{ deviceHistCount.bumpeCount || '-' }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div
          class="card count-device"
          v-if="funcView.dashboard_time_outside_statistics_unused || funcView.dashboard_time_outside_statistics_offline || funcView.dashboard_time_outside_statistics_fault"
        >
          <div class="pie">
            <div class="header">
              <h4>{{ $t('base_dashboard.jqsjglt') }}</h4>
              <p v-if="orderWorkHistCount.pastEndTime" v-text="'<= ' + momentAmPm($momentLocal(orderWorkHistCount.pastEndTime))"></p>
              <el-radio-group v-model="formSearch.utsideDays" @change="getOrderWorkHistCount()">
                <el-radio-button :label="item.value" v-for="(item, index) in utsideDay" :key="index">{{ item.label }}</el-radio-button>
              </el-radio-group>
            </div>
            <div class="pie-row">
              <el-row :gutter="10">
                <el-col :span="4" v-if="funcView.dashboard_time_outside_statistics_unused">
                  <div class="grid-content">
                    <h6>{{ $t('base_dashboard.wei_shi_yong_ji_qi') }}</h6>
                    <p @click="onDeviceStatusCount(null, 'cleanTime', orderWorkHistCount.pastEndTime)">{{ orderWorkHistCount.unUse || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4" v-if="funcView.dashboard_time_outside_statistics_offline">
                  <div class="grid-content">
                    <h6>{{ $t('base_dashboard.li_xian_ji_qi') }}</h6>
                    <p @click="onDeviceStatusCount(null, 'onlineTime', orderWorkHistCount.pastEndTime)">{{ orderWorkHistCount.offline || '-' }}</p>
                  </div>
                </el-col>
                <el-col :span="4" v-if="funcView.dashboard_time_outside_statistics_fault">
                  <div class="grid-content">
                    <h6>{{ $t('base_dashboard.gu_zhang_ji_qi') }}</h6>
                    <p @click="onMalfunctionCount(orderWorkHistCount.pastEndTime)">{{ orderWorkHistCount.malfunction || '-' }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div
          class="card line-chart"
          v-if="
            funcView.dashboard_trend_chart_machine_business ||
            funcView.dashboard_trend_chart_customer_count ||
            funcView.dashboard_trend_chart_machine_cleaning ||
            funcView.dashboard_trend_chart_receivables ||
            funcView.dashboard_trend_chart_work_order
          "
        >
          <div class="pie">
            <div class="header">
              <el-radio-group v-model="formSearch.statisticsType" @change="onStatisticsTypeChange()">
                <el-radio-button :label="item.value" v-for="(item, index) in statisticsTypeData" :key="index">{{ item.label }}</el-radio-button>
              </el-radio-group>
              <!-- <template> -->
              <!-- 天 -->
              <!--  @init="onTypeChange" -->
              <custom-date-picker
                v-show="formSearch.statisticsType === 0"
                v-model="dateTimes"
                type="daterange"
                align="right"
                unlink-panels
                :start-placeholder="$t('base_dashboard.kai_shi_ri_qi')"
                :end-placeholder="$t('base_dashboard.jie_shu_ri_qi')"
                :picker-options="pickerOptionsIntervalMonthReport"
                @change="onStatisticsTypeChange"
                style="width: 340px"
              ></custom-date-picker>
              <!-- 历史报表 -->
              <!-- 年 -->
              <year-picker
                v-show="formSearch.statisticsType === 1"
                :isInterval="true"
                v-model="reportYearTime"
                class="year-picker"
                style="width: 260px; line-height: 32px"
                @change="onStatisticsTypeChange"
              ></year-picker>
              <!-- 季度 -->
              <season-picker
                v-show="formSearch.statisticsType === 2"
                v-model="reportSeasonTime"
                :isInterval="true"
                ref="jidupicker"
                class="season-picker"
                style="width: 330px"
                @change="onStatisticsTypeChange"
              ></season-picker>
              <!-- 月 -->
              <custom-date-picker
                v-show="formSearch.statisticsType === 3"
                v-model="reportMonthTime"
                type="monthrange"
                range-separator="—"
                value-format="yyyy-MM"
                align="right"
                placeholder=""
                :picker-options="pickerOptionsIntervalThreeYears"
                prefix-icon="icon icon-calendar"
                :clearable="false"
                :start-placeholder="$t('base_dashboard.kai_shi_yue')"
                :end-placeholder="$t('base_dashboard.jie_shu_yue')"
                style="width: 340px"
                @change="onStatisticsTypeChange"
              ></custom-date-picker>
              <!--周 -->
              <week-picker
                v-show="formSearch.statisticsType === 4"
                v-model="reportWeekTime"
                :isInterval="true"
                class="week-picker"
                style="width: 340px; line-height: 32px"
                @change="onStatisticsTypeChange"
              ></week-picker>
              <!-- </template> -->
            </div>
            <div class="line-chart-wrap">
              <ul class="line-chart-list">
                <div class="line-chart-item" v-if="funcView.dashboard_trend_chart_machine_business"><sheet-line :lineData="deviceBizSheetList" lineType="1" :isfull="isfull" /></div>
                <div class="line-chart-item" v-if="funcView.dashboard_trend_chart_customer_count"><sheet-line :lineData="customerSheetList" lineType="2" :isfull="isfull" /></div>
                <div class="line-chart-item" v-if="funcView.dashboard_trend_chart_machine_cleaning"><sheet-line :lineData="deviceCleanSheetList" lineType="3" :isfull="isfull" /></div>
                <div class="line-chart-item" v-if="funcView.dashboard_trend_chart_receivables"><sheet-line :lineData="billSheetList" lineType="4" :isfull="isfull" /></div>
              </ul>
              <div class="line-chart-item overall" v-if="funcView.dashboard_trend_chart_work_order">
                <sheet-line class-name="workorder-sheet" :lineData="workOrderSheetList" lineType="5" :isfull="isfull" />
              </div>
            </div>
          </div>
        </div>
        <div class="card fault-table" v-if="funcView.dashboard_fault_ranking_table">
          <div class="header">
            <h4>
              {{ $t('base_dashboard.gzpxq20j14tn') }}
            </h4>
            <custom-select
              type="tree"
              url="adminPortalProductComponent"
              v-model="formSearch.componentCode"
              :props="{ label: 'name', value: 'value', checkStrictly: true }"
              :dataFilter="componentFilter"
              :placeholder="$t('base_dashboard.xing_hao_bu_jian')"
              width="170px"
              @treeValChange="getEventStatistics()"
              style="margin-left: 24px"
            ></custom-select>
            <custom-select
              v-model="formSearch.eventType"
              code="iot_tsl_event_type"
              :placeholder="$t('base_dashboard.shi_jian_lei_xing')"
              width="120px"
              :dataFilter="eventTypeFilter"
              @change="getEventStatistics()"
              style="margin-left: 24px"
            ></custom-select>
            <search-input v-model="formSearch.machineVersion" :placeholder="$t('base_dashboard.ji_qi_ban_ben')" style="width: 170px; height: 32px; margin-left: 24px" @fetch="getEventStatistics()"></search-input>
          </div>
          <div class="table-event">
            <ul class="table-head">
              <li class="code">
                <span class="num-th">{{ $t('base_dashboard.chan_pin_xing_hao') }}</span>
              </li>
              <li>
                <span>{{ $t('base_dashboard.bu_jian') }}</span>
              </li>
              <li>
                <span>{{ $t('base_dashboard.shi_jian_lei_xing') }}</span>
              </li>
              <!-- 新 -->
              <li>
                <span>{{ $t('base_dashboard.V3dai_ma') }}</span>
              </li>
              <li>
                <span>{{ $t('base_dashboard.V4dai_ma') }}</span>
              </li>
              <li>
                <span>{{ $t('base_dashboard.shi_jian_dai_ma') }}</span>
              </li>
              <li class="label">
                <span>{{ $t('base_dashboard.shi_jian_ming_cheng') }}</span>
              </li>
              <li>
                <span>
                  <custom-sort @sort-change="onSortChange" prop="eventTotal" :orderBy="orderBy" :key="'eventTotal'">{{ $t('base_dashboard.shi_jian_zong_shu') }}</custom-sort>
                </span>
              </li>
              <li>
                <span>
                  <custom-sort @sort-change="onSortChange" prop="deviceTotal" :orderBy="orderBy" :key="'deviceTotal'">{{ $t('base_dashboard.ji_qi_zong_shu') }}</custom-sort>
                </span>
              </li>
              <li class="sheet">
                <i></i>
                <span class="event">{{ $t('base_dashboard.shi_jian_shu') }}</span>
                <i class="bar"></i>
                <span class="machine">{{ $t('base_dashboard.ji_qi_shu') }}</span>
              </li>
            </ul>
            <ul class="table-body">
              <template v-if="eventStatisticsList.length > 0">
                <li class="line" v-for="(item, index) in eventStatisticsList" :key="index">
                  <ul class="content">
                    <li class="code">
                      <div class="num-info">
                        <span>{{ index + 1 }}</span>
                        <div class="text">
                          <p>{{ item.productCode }}</p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="text">
                        <p>{{ item.componentName }}</p>
                        <p>{{ item.component }}</p>
                      </div>
                    </li>
                    <li>
                      <span>{{ getDicValue('iot_tsl_event_type', item.eventType) }}</span>
                    </li>
                    <li>
                      <span>{{ item.hmiV3Code }}</span>
                    </li>
                    <li>
                      <span>{{ item.hmiV4Code }}</span>
                    </li>
                    <li>
                      <span>{{ item.eventCode }}</span>
                    </li>
                    <li class="label">
                      <span :title="item.eventName">{{ item.eventName }}</span>
                    </li>
                    <li class="num">
                      <span>{{ item.eventTotal }}</span>
                    </li>
                    <li class="num num-device" @click="onDeviceCount(item)">
                      <span>{{ item.deviceTotal }}</span>
                    </li>
                    <li class="sheet">
                      <!-- <div class="fault-sheet"></div> -->
                      <sheet-line class-name="fault-sheet" :lineData="item.details" :item="item" lineType="6" @clickLine="onDeviceCount" />
                    </li>
                  </ul>
                </li>
              </template>
              <template v-else>
                <li class="no-data">{{ isLoadings ? $t('base_dashboard.jia_zai_zhong') : $t('Common.com_no_data') }}</li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <!-- !isfull && -->
      <div :class="{ hide: isfull }" class="dashboard-wrap-right" v-show="funcView.dashboard_quick_entry_menu || funcView.dashboard_quick_entry_todo">
        <div class="nav nav-entry" v-if="funcView.dashboard_quick_entry_menu">
          <div class="header">
            <i class="icon icon-Vector"></i>
            <h4>{{ $t('base_dashboard.kuai_jie_ru_kou') }}</h4>
            <i class="icon icon-bianji" @click="onQueryMenu" v-if="funcView.dashboard_quick_entry_edit"></i>
          </div>
          <ul class="entry-list" v-if="favoriteMenuList.length > 0">
            <li @click="jump(`${item.loadRes}`, null, null, true)" v-for="item in favoriteMenuList" :key="item.menuId">
              <span>{{ item.menuName }}</span>
              <i class="icon icon-you"></i>
            </li>
          </ul>
        </div>
        <div class="nav nav-pending" v-if="waitApproveList.length > 0 && funcView.dashboard_quick_entry_todo">
          <div class="header">
            <i class="icon icon-a-11"></i>
            <h4>{{ $t('base_dashboard.dai_ban_shi_xiang') }}</h4>
          </div>
          <ul class="entry-list">
            <li @click="onWorkflowType(item)" v-for="item in waitApproveList" :key="item.workflowType">
              <span class="type">{{ getDicValue('approval_type', item.workflowType) }}</span>
              <span class="num">{{ item.waitApproveCount }}</span>
              <i class="icon icon-you"></i>
            </li>
          </ul>
        </div>
      </div>
      <i class="icon icon-full" :class="{ 'icon-full-right': isfull, 'icon-huadongjiesuo2-copy': isfull, 'icon-huadongjiesuo': !isfull }" @click="isfull = !isfull"></i>
    </div>
    <!--高级筛选 -->
    <dashboard-search-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSearchSuccess"></dashboard-search-dialog>
    <dashboard-count-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @openBack="onOpenBackCount"></dashboard-count-dialog>
    <dashboard-meun-bind-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getFavoriteQueryMenu"></dashboard-meun-bind-dialog>
    <dashboard-fault-count-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false" @openBack="onOpenBackFaultCount"></dashboard-fault-count-dialog>
  </div>
</template>

<script>
// 快捷入口 - 菜单   dashboard_quick_entry_menu
// 快捷入口 - 设置   dashboard_quick_entry_edit
// 待办事项 dashboard_quick_entry_todo
// 实时状态 - 菜单 dashboard_realtime_status
// 实时状态 - 锁机 dashboard_realtime_status_lock
// 实时状态 - 故障 dashboard_realtime_status_fault
// 实时状态 - 节能 dashboard_realtime_status_energy
// 实时状态 - 机器未激活 dashboard_realtime_status_machine_not_activated
// 实时状态 - SIM未激活 dashboard_realtime_status_sim_not_activated
// 实时状态 - 锁机工作 dashboard_realtime_status_lock_work

// 业务状态 - 菜单 dashboard_business_status
// 业务状态 -昨日使用率 dashboard_business_status_rate
// 产品数量 dashboard_business_status_product
// 故障型号 dashboard_business_status_fault
// 固件版本 dashboard_firmware_version
// 工单情况 - 待接单 - 菜单  dashboard_work_order_pending
// 工单情况 - 待接单 - 筛选  dashboard_work_order_pending_filter
// 工单情况 - 处理中 - 菜单  dashboard_work_order_processing
// 工单情况 - 处理中 - 筛选  dashboard_work_order_processing_filter

// 财务账单 - 收款  dashboard_financial_invoice_receipt
// 财务账单 - 付款   dashboard_financial_invoice_payment
// 财务账单 - 收款及时率 dashboard_financial_receipt_timeliness
// 财务账单 - 付款及时率   dashboard_financial_payment_timeliness

// 时间内统计 - 租出  dashboard_within_statistics_rented
// 时间内统计 - 试用  dashboard_time_within_statistics_trial
// 时间内统计 - 已售 dashboard_time_within_statistics_sold
// 时间内统计 - 将到期 dashboard_time_within_statistics_expire
// 时间内统计 - 库存到期 dashboard_time_within_statistics_expiration
// 时间内统计 - 未上传运行图 dashboard_time_within_statistics_no_upload_chart
// 时间内统计 - 未上传地图 dashboard_time_within_statistics_no_upload_map
// 时间内统计 - 未上传清洁记录 dashboard_time_within_statistics_no_upload_record
// 时间内统计 - 未完成清洁 dashboard_time_within_statistics_incomplete_clean
// 时间内统计 - 悬崖触发 dashboard_time_within_statistics_cliff
// 时间内统计 - 碰撞触发 dashboard_time_within_statistics_collision

// 时间外统计 - 未使用 dashboard_time_outside_statistics_unused
// 时间外统计 - 离线 dashboard_time_outside_statistics_offline
// 时间外统计 - 故障 dashboard_time_outside_statistics_fault

// 趋势图 - 机器业务 dashboard_trend_chart_machine_business
// 趋势图 - 客户数量  dashboard_trend_chart_customer_count
// 趋势图 - 机器清洁 dashboard_trend_chart_machine_cleaning
// 趋势图 - 账款 dashboard_trend_chart_receivables
// 趋势图 - 工单 dashboard_trend_chart_work_order

// 故障排行表 dashboard_fault_ranking_table
import moment from 'moment';
import apis from '@/utils/apis';
import seasonPicker from '@/components/quarterlyRangePicker.vue';
import customSort from '@/components/customSort.vue';
import yearPicker from '@/components/yearRangePicker.vue';
import weekPicker from '@/components/weekRangePicker.vue';
import myPie from './children/pie.vue';
import sheetLine from './children/line.vue';
import dashboardSearchDialog from './children/dashboard_search_dialog.vue';
import dashboardCountDialog from './children/dashboard_count_dialog.vue';
import dashboardMeunBindDialog from './children/dashboard_meun_bind_dialog.vue';
import dashboardFaultCountDialog from './children/dashboard_fault_count_dialog.vue';
// 定义颜色数组
const colorsArray = [
  '#00A0D9',
  '#FFAD00',
  '#93DA49',
  '#EB5A5A',
  '#F30472',
  '#7CECD9',
  '#8E01BD',
  '#C150CD',
  '#B5513E',
  '#5DFDEC',
  '#54F8DB',
  '#B8C083',
  '#7043a2',
  '#bee3e6',
  '#70f889',
  '#53fae3',
  '#18d247',
  '#93ce5a',
  '#c9eb71',
  '#b9b482',
  '#262e56',
  '#37a27c',
  '#ac5d39',
  '#87f1e4',
  '#f30b75',
  '#cf95a4',
  '#a6adb4',
  '#d3bfcf',
  '#e36763',
  '#707088',
  '#4f6564',
  '#ffaf0b',
  '#bd66ce',
  '#0aa5dc',
  '#f1f1f1',
  '#cae1b2',
  '#8b13b5',
  '#c07ad2',
  '#94be71',
  '#adf6ba',
  '#96cbb5',
  '#b4c286',
  '#ec5859',
  '#a46e3b',
  '#cbddaf',
  '#666780',
  '#be91a9',
  '#d6a99c',
  '#80f397',
  '#f27d97',
  '#53ae8d',
  '#97f6e9',
];
export default {
  name: 'dashboard',
  components: { myPie, sheetLine, customSort, seasonPicker, yearPicker, weekPicker, dashboardSearchDialog, dashboardCountDialog, dashboardMeunBindDialog, dashboardFaultCountDialog },
  computed: {
    dataTypeData() {
      return [
        {
          label: this.$t('Common.com_all'),
          value: '0',
        },
        {
          label: this.$t('base_dashboard.zu_lin'),
          value: '1',
        },
        {
          label: this.$t('base_dashboard.zai_ku'),
          value: '2',
        },
        {
          label: this.$t('base_dashboard.yi_shou'),
          value: '4',
        },
      ];
    },
    statisticsTypeData() {
      return [
        {
          label: this.$t('base_dashboard.ri'),
          value: 0,
        },
        {
          label: this.$t('base_dashboard.zhou'),
          value: 4,
        },
        {
          label: this.$t('base_dashboard.yue'),
          value: 3,
        },
        {
          label: this.$t('base_dashboard.ji'),
          value: 2,
        },
        {
          label: this.$t('base_dashboard.nian'),
          value: 1,
        },
      ];
    },
    withinDay() {
      return [
        {
          label: this.$t('base_dashboard.30tian_nei'),
          value: '30',
        },
        {
          label: this.$t('base_dashboard.15tian_nei'),
          value: '15',
        },
        {
          label: this.$t('base_dashboard.7tian_nei'),
          value: '7',
        },
      ];
    },
    utsideDay() {
      return [
        {
          label: this.$t('base_dashboard.30tian'),
          value: '30',
        },
        {
          label: this.$t('base_dashboard.15tian'),
          value: '15',
        },
        {
          label: this.$t('base_dashboard.7tian'),
          value: '7',
        },
      ];
    },
    workOrganTypeData() {
      return [
        {
          label: this.$t('base_dashboard.zu_zhi'),
          value: 1,
        },
        {
          label: this.$t('base_dashboard.wo_de'),
          value: 2,
        },
      ];
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    bizType() {
      return this.userInfo.bizType;
    },
    today() {
      const d = this.$moment(this.$getLocalTime()).format(this.$t('base_dashboard.YYYYnianMMyueDDri'));
      return d;
    },
    weekday() {
      const arr = [this.$t('base_dashboard.xing_qi_ri'), this.$t('base_dashboard.xing_qi_yi'), this.$t('base_dashboard.xing_qi_er'), this.$t('base_dashboard.xing_qi_san'), this.$t('base_dashboard.xing_qi_si'), this.$t('base_dashboard.xing_qi_wu'), this.$t('base_dashboard.xing_qi_liu')];
      return arr[this.$moment(this.$getLocalTime()).get('days')];
    },
    timeDay() {
      const arr = [this.$t('base_dashboard.ling_chen_hao'), this.$t('base_dashboard.zao_shang_hao'), this.$t('base_dashboard.shang_wu_hao'), this.$t('base_dashboard.zhong_wu_hao'), this.$t('base_dashboard.xia_wu_hao'), this.$t('base_dashboard.wan_shang_hao')];
      const hour = moment(this.$getLocalTime()).hour();
      let timeOfDay = '';
      switch (true) {
        case hour >= 0 && hour < 6: // 凌晨
          timeOfDay = arr[0];
          break;
        case hour >= 6 && hour < 9: // 早上
          timeOfDay = arr[1];
          break;
        case hour >= 9 && hour < 12: // 上午
          timeOfDay = arr[2];
          break;
        case hour === 12: // 中午
          timeOfDay = arr[3];
          break;
        case hour > 12 && hour <= 17: // 下午
          timeOfDay = arr[4];
          break;
        default: // 其他情况都认为是晚上
          timeOfDay = arr[5];
      }
      return timeOfDay;
    },
    // 机器状态的动态 stateDefinitions
    deviceStatusStateDefinitions() {
      return {
        using: { itemStyle: { color: '#93da49' } },
        idle: { itemStyle: { color: '#00a0d9' } },
        charging: { itemStyle: { color: '#ffad00' } },
        offline: { itemStyle: { color: '#b3b3b3' } },
      };
    },
    // 业务的动态 stateDefinitions
    deviceBizStateDefinitions() {
      return [
        { code: 'zlz', state: ['22'], label: this.$t('base_dashboard.zu_lin'), color: '#00A0D9 ' },
        { code: 'zkz', state: ['12'], label: this.$t('base_dashboard.zai_ku'), color: '#536E61' },
        { code: 'syz', state: ['24'], label: this.$t('base_dashboard.shi_yong'), color: '#C6E6E3' },
        { code: 'dqz', state: ['21'], label: this.$t('base_dashboard.dai_qi_zu'), color: '#C150CD' },
        { code: 'ydq', state: ['45'], label: this.$t('base_dashboard.yi_dao_qi'), color: '#FFAD00' },
        { code: 'ygj', state: ['52'], label: this.$t('base_dashboard.yi_shou'), color: '#B3B3B3' },
        { code: 'ztz', state: ['15'], label: this.$t('base_dashboard.zai_tu_zhong'), color: '#93DA49' },
        { code: 'ygh', state: ['42'], label: this.$t('base_dashboard.yi_geng_huan'), color: '#F30472' },
        { code: 'ywy', state: ['43'], label: this.$t('base_dashboard.yi_wei_yue'), color: '#EB5A5A' },
      ];
    },
    // 工单的动态 stateDefinitions
    workOrderStateDefinitions() {
      return [
        { code: 'maintain', state: ['10'], label: this.$t('base_dashboard.wei_xiu'), color: '#EB5A5A' },
        { code: 'upkeep', state: ['20'], label: this.$t('base_dashboard.bao_yang'), color: '#00A0D9' },
        { code: 'refurbish', state: ['60'], label: this.$t('base_dashboard.fan_xin'), color: '#93DA49' },
        { code: 'rework', state: ['50'], label: this.$t('base_dashboard.fan_gong'), color: '#FFAD00' },
      ];
    },
    // 账单的动态 stateDefinitions
    billStateDefinitions() {
      return [
        {
          code: 'thisMonthAmount',
          state: 'thisMonthAmount',
          label: this.$t('base_dashboard.ben_yue_ying_shou'),
          plabel: this.$t('base_dashboard.ben_yue_ying_fu'),
          color: '#F5F5F5',
          itemStyle: { color: '#00A0D9' },
        },
        {
          code: 'thisMonthPayment',
          state: 'thisMonthPayment',
          label: this.$t('base_dashboard.ben_yue_yi_shou'),
          plabel: this.$t('base_dashboard.ben_yue_yi_fu'),
          color: '#00A0D9',
          itemStyle: { color: '#F5F5F5' },
        },
      ];
    },
  },
  data() {
    return {
      // 全屏
      isfull: false,
      formSearch: {
        dataType: 0,

        // pageSize: 16,
        // pageNum: 1,
        productCode: [],
        productName: [],
        // 高级筛选
        customerId: '',
        customerName: '',
        agentCoId: '',
        agentCoName: '',
        afterServiceId: '',
        afterServiceName: '',
        locationName: '',
        locationId: '',
        // 下面独立
        // product: '',
        componentCodeVersion: ['Cobi18', 'modem'],
        withinDays: 30,
        utsideDays: 30,

        // 趋势图
        statisticsType: 0,
        beginTime: '',
        endTime: '',
        // 工单组织类型
        workOrganType: 1,
        // 故障排行筛选
        eventType: '',
        componentCode: [],
        machineVersion: '',
      },
      // 日
      dateTimes: [moment(this.$getLocalTime()).subtract(14, 'day').format('YYYY-MM-DD 00:00:00'), moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 23:59:59')],
      reportYearTime: [`${moment(this.$getLocalTime()).subtract(2, 'year').year()}`, `${moment(this.$getLocalTime()).year()}`],
      reportSeasonTime: [
        `${new Date(new Date().setFullYear(new Date().getFullYear() - 2)).getFullYear()}-${this.getSeason(new Date().getMonth())}`,
        `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`,
      ],
      reportMonthTime: [`${moment(this.$getLocalTime()).subtract(7, 'month').add('month').format('YYYY-MM')}`, `${moment().add('month').format('YYYY-MM')}`],

      reportWeekTime: [this.$momentElLocal(moment().week(moment().week() - 7)), this.$momentElLocal(moment().week(moment().week()))],
      // 机器状态
      deviceStatusCount: {
        stateList: [],
        total: 0,
      },
      // 型号数据
      productCountList: [],
      // 机器业务
      deviceBizCount: {},
      // -----------------
      // 工单
      workOrderCount: {
        wait: {
          stateList: [],
          total: 0,
        },
        process: {
          stateList: [],
          total: 0,
        },
      },
      billOrderCount: {
        receivable: {
          stateList: [],
          total: 0,
          ratioAmount: 0,
          ratioList: [],
          ratio: 0,
          nextMonthAmount: 0,
        },
        payment: {
          stateList: [],
          total: 0,
          ratioAmount: 0,
          ratioList: [],
          ratio: 0,
          nextMonthAmount: 0,
        },
      },

      // 故障型号
      faultProductCount: {
        detailList: [],
        total: '',
      },
      // 型号组件
      componentSearch: {
        list: [],
      },

      // 型号组件版本
      productComponentVersionCount: {
        versionList: [],
        total: '',
      },

      // 机器数据统计
      deviceHistCount: {
        pastEndTime: '',
        pastStartTime: '',
      },
      // 机器状态统计
      orderHistCount: {
        futureEndTime: '',
        futureStartTime: '',
        pastEndTime: '',
        pastStartTime: '',
      },
      // 运行上传历史统计
      orderWorkHistCount: {
        unUse: '',
        offline: '',
        malfunction: '',
        pastEndTime: '',
        pastStartTime: '',
      },
      // 趋势图
      deviceBizSheetList: [],
      customerSheetList: [],
      deviceCleanSheetList: [],
      billSheetList: [],
      workOrderSheetList: [],

      // 故障排行
      eventStatisticsList: [],
      isLoadings: false,
      orderBy: '',
      orderType: '',

      favoriteMenuList: [],
      waitApproveList: [],
      // 弹窗
      dialogVisible: false,
      dialogModel: {},
      // 次数 弹窗
      dialogVisible1: false,
      dialogModel1: {},
      isOpenCount: false,
      openFormSearchCount: null,
      // K
      dialogVisible2: false,
      dialogModel2: {},
      // 筛选
      tagId: '',
      tags: [],
      isFilter: false,
      selectedProductCodeItems: [],
      // 机器总数
      dialogVisible3: false,
      dialogModel3: {},
      isOpenFaultCount: false,
      openFormSearchFaultCount: null,
    };
  },
  mounted: function () {
    this.formSearch.beginTime = this.initValue ? this.initValue[0] : '';
    this.formSearch.endTime = this.initValue ? this.initValue[1] : '';
    this.getFuncView(null, () => {
      this.onTypeChange();
    });
  },
  activated: function () {
    // 次数页面返回展开
    if (this.isOpenCount) {
      this.isOpenCount = false;
      this.dialogVisible1 = true;
      this.dialogModel1.formSearch = this.openFormSearchCount;
    }
    if (this.isOpenFaultCount) {
      this.isOpenFaultCount = false;
      this.dialogVisible3 = true;
      this.dialogModel3.formSearch = this.openFormSearchFaultCount;
    }
  },
  created() {
    moment.updateLocale('en', {
      week: {
        dow: 1, // Monday is the first day of the week.
        doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
      },
    });
    this.initValue = [
      this.$momentWorld(this.$moment(this.$getLocalTime()).subtract(14, 'day').format('YYYY-MM-DD  00:00:00')),
      this.$momentWorld(this.$moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 23:59:59')),
    ];
  },
  methods: {
    componentFilter(list) {
      let ret = [...list];
      // 给第一层和第二层加字段
      ret = ret.map((item) => {
        // 给第一层添加字段
        item.name = item.productCode;
        item.value = item.productCode;

        // 如果有子节点（components），处理每一个子节点
        if (item.componentList && Array.isArray(item.componentList)) {
          item.children = item.componentList.map((component) => {
            // 给第二层添加字段
            component.name = component.componentName;
            component.value = component.componentCode;
            return component;
          });
        }

        return item;
      });
      return ret;
    },
    eventTypeFilter(list) {
      return list.filter((item) => `${item.value}` === '22' || `${item.value}` === '23');
    },
    // 机器状态
    getDeviceStatusCount(flag) {
      // 定义状态列表
      const stateDefinitions = this.deviceStatusStateDefinitions;
      this.$getJSON(apis.adminPortalDeviceStatusCount, this.formSearch).then(async (res) => {
        const deviceStatusCount = res.data || {};

        // 添加 stateList 数组
        deviceStatusCount.stateList = [];
        // 遍历 deviceStatusCount 对象
        for (const key in deviceStatusCount) {
          if (stateDefinitions[key]) {
            const value = deviceStatusCount[key];
            deviceStatusCount.stateList.push({
              ...stateDefinitions[key],
              value: value, // 如果需要保留原来的值
            });
          }
        }
        // flag 为 true 时，重新加载 productCountList
        this.deviceStatusCount = deviceStatusCount;
        if (this.productCountList.length === 0 || flag) {
          // 避免二次重置 productCountList
          const productCountList = deviceStatusCount.productCountList || [];
          // 加载图片附件
          this.productCountList = await this.formatAttachList(productCountList, 'productCodeId', 'dms.product.icon');
        }
      });
    },
    // 业务
    getDeviceBizCount() {
      const _this = this;
      // 定义状态列表
      const stateDefinitions = this.deviceBizStateDefinitions;

      this.$getJSON(apis.adminPortalDeviceBizCount, this.formSearch).then((res) => {
        const deviceBizCount = res.data || {};
        if (res.data.total === 0) {
          // 图表置空
          deviceBizCount.stateList = [];
          this.deviceBizCount = deviceBizCount;
          return;
        }
        // 创建一个新的 stateList，保持与 stateDefinitions 的顺序一致
        deviceBizCount.stateList = stateDefinitions
          .map((definition, index) => {
            const item = deviceBizCount.stateList.find((stem) => stem.state === definition.state.join());
            return {
              value: item ? item.num : 0, // 如果找到对应项，则使用 num，否则设置为 0
              state: definition.state,
              itemStyle: { color: definition.color }, // 修改为 itemStyle
              get label() {
                // 利用 Getter，页面每次取值都会实时拿到字典编译后的最新结果！
                return _this.deviceBizStateDefinitions[index].label;
              },
            };
          })
          .filter((item) => item.value > 0); // 过滤掉 value 为 0 的项;

        this.deviceBizCount = deviceBizCount;
      });
    },
    // 工单
    getworkOrderStatistics() {
      const _this = this;
      // 定义状态列表
      const stateDefinitions = this.workOrderStateDefinitions;
      this.$getJSON(apis.workOrderStatistics, {
        ...this.formSearch,
        statisticsType: this.formSearch.workOrganType, // 1-组织工单统计，2-个人工单统计
        // workOrderState: ['40'], // 工单状态 40-待接单，50-已接单，60-上门中，70-已到达，90-已解决，91-未解决，100-已完成，120-已关闭
      }).then((res) => {
        const workOrderCount = res.data || {};
        workOrderCount.forEach((item) => {
          // 使用stateStatisticsType的值作为新键
          const key = item.stateStatisticsType; // 获取stateStatisticsType的值
          item.info.stateList = stateDefinitions.map((definition, index) => {
            const fitem = item.info.details.find((stem) => `${stem.workOrderType}` === definition.state.join());
            return {
              value: fitem ? fitem.workOrderCount : 0, // 如果找到对应项，则使用 num，否则设置为 0
              state: definition.state,
              itemStyle: { color: definition.color }, // 修改为 itemStyle
              get label() {
                // 利用 Getter，页面每次取值都会实时拿到字典编译后的最新结果！
                return _this.workOrderStateDefinitions[index].label;
              },
            };
          });
          delete item.info.details;
          // 根据stateStatisticsType将处理后的内容添加到result对象中
          this.workOrderCount[key] = item.info;
        });
      });
    },
    // 故障型号
    getFaultProductCount() {
      this.$getJSON(apis.adminPortalfaultProductCount, this.formSearch).then((res) => {
        const faultProductCount = res.data || {};
        if (res.data.total === 0) {
          // 图表置空
          faultProductCount.detailList = [];
          this.faultProductCount = faultProductCount;
          return;
        }
        // 使用 map 方法创建一个新的 detailList，新增 value 和 color 字段
        faultProductCount.detailList = faultProductCount.detailList.map((item, index) => ({
          ...item, // 保留原有的其他属性
          value: item.malfunction, // 新增 value 字段，取 malfunction 的值
          // productColor 型号颜色属性
          itemStyle: { color: item.productColor || colorsArray[index] }, // 新增 color 字段，对应 colorsArray 中的值
        }));
        this.faultProductCount = faultProductCount;
      });
    },
    // 故障型号
    onProductCode(item) {
      // 第一次'Cobi18' 'modem'
      if (item && !(item.productCode === 'Cobi18' && this.formSearch.componentCode === 'modem')) {
        this.formSearch.componentCode = item.componentList[0].componentCode;
      } else if (item && item.productCode === 'Cobi18' && this.formSearch.componentCode === 'modem') {
        this.formSearch.componentCode = 'modem';
      } else {
        this.formSearch.componentCode = '';
      }
      if (this.funcView.dashboard_firmware_version) {
        // 固件版本
        this.getProductComponentVersionCount();
      }
    },
    // 固件版本
    getProductComponentVersionCount() {
      this.$getJSON(apis.adminPortalProductComponentVersionCount, {
        ...this.formSearch,
        product: this.formSearch.componentCodeVersion[0],
        componentCode: this.formSearch.componentCodeVersion[1],
      }).then((res) => {
        const productComponentVersionCount = res.data || {};
        if (res.data.total === 0) {
          // 图表置空
          productComponentVersionCount.versionList = [];
          this.productComponentVersionCount = productComponentVersionCount;
          return;
        }
        // 使用 map 方法创建一个新的 detailList，新增 value 和 color 字段
        productComponentVersionCount.versionList = productComponentVersionCount.versionList.map((item, index) => ({
          ...item, // 保留原有的其他属性
          value: item.num, // 新增 value 字段，取 malfunction 的值
          itemStyle: { color: colorsArray[index] }, // 新增 color 字段，对应 colorsArray 中的值
        }));

        this.productComponentVersionCount = productComponentVersionCount;
      });
    },
    // 收付款
    getbillOrderCount() {
      const _this = this;
      // 定义状态列表
      const stateDefinitions = this.billStateDefinitions;
      // const receivableOrgType = this.bizType === 'HQ' ? 'SC' : 'HQ';
      this.$getJSON(apis.billOrderTermStatistics, {
        ...this.formSearch,
      }).then((res) => {
        const billOrderCount = res.data;

        // 处理数据并填充 billOrderCount
        billOrderCount.forEach((item) => {
          // 直接使用 billStatisticsType 作为 key
          const billKey = item.billStatisticsType;

          // 初始化状态列表
          const stateList = [];

          //    code: 'thisMonthAmount', state: 'thisMonthAmount', label: '本月应收', plabel: '本月应付', itemStyle: { color: '#00A0D9' } },
          // { code: 'thisMonthPayment'
          // 根据 stateDefinitions 填充状态列表
          stateDefinitions.forEach((stateDef, index) => {
            stateList.push({
              state: stateDef.state,
              itemStyle: stateDef.itemStyle,
              color: stateDef.color,
              value:
                stateDef.code === 'thisMonthAmount'
                  ? Math.round((item.info.thisMonthPayment / item.info.thisMonthAmount) * 100)
                  : Math.round(100 - (item.info.thisMonthPayment / item.info.thisMonthAmount) * 100), // 从 info 中提取值
              amount: item.info[stateDef.code], // 金额用于显示
              get label() {
                // 根据 billKey 动态决定是拿 label(应收) 还是 plabel(应付)
                return billKey === 'receivable'
                  ? _this.billStateDefinitions[index].label
                  : _this.billStateDefinitions[index].plabel;
              }
            });
          });

          // 填充 stateList
          this.billOrderCount[billKey].stateList = stateList;
          this.billOrderCount[billKey].total = item.info.thisMonthAmount;
          this.billOrderCount[billKey].nextMonthAmount = item.info.nextMonthAmount;
          this.billOrderCount[billKey].ratioAmount = Math.round((item.info.thisMonthPayment / item.info.thisMonthAmount) * 100) || 0;

          // 处理 ratioList
          const ratio = item.ratio;
          // const amount = item.info.thisMonthAmount;
          this.billOrderCount[billKey].ratioList = [];
          // 计算基于 ratio 的数据
          if (ratio > 0) {
            // const ratioValue = amount * ratio; // 比率部分
            // const remainingValue = 100 - ratioValue; // 剩余部分

            // 添加到 ratioList
            this.billOrderCount[billKey].ratioList.push(
              {
                code: 'thisMonthAmount',
                state: 'thisMonthAmount',
                value: Math.round(ratio),
                label: billKey === 'receivable' ? stateDefinitions[0].label : stateDefinitions[1].label, // 使用 stateDefinitions 中的 label,
                itemStyle: { color: this.getColorByRatio(ratio) }, // 修改为 itemStyle
                ratio: `${ratio}%`, // 保留 ratio 字段
              },
              {
                code: 'thisMonthPayment',
                state: 'thisMonthPayment',
                value: Math.round(100 - ratio),
                label: billKey === 'receivable' ? stateDefinitions[0].label : stateDefinitions[1].label, // 使用 stateDefinitions 中的 label
                itemStyle: { color: '#F5F5F5' }, // 修改为 itemStyle
                ratio: `${(100 - ratio).toFixed(2)}%`, // 保留剩余的比例
              }
            );
          }
          this.billOrderCount[billKey].ratio = Math.round(item.ratio) || 0;
        });
      });
    },
    // 算颜色
    getColorByRatio(ratio) {
      // 80% 蓝色，60%-80% 橙色，<=60% 以下红色
      let color;
      if (ratio >= 80) {
        color = '#00A0D9';
      } else if (ratio >= 60) {
        color = '#FAC04C';
      } else {
        color = '#EB5A5A';
      }
      return color;
    },
    onWithinDay() {
      // this.getDeviceHistCount();
      // this.getOrderHistCount();

      if (
        this.funcView.dashboard_within_statistics_rented
        || this.funcView.dashboard_time_within_statistics_trial
        || this.funcView.dashboard_time_within_statistics_sold
        || this.funcView.dashboard_time_within_statistics_expire
        || this.funcView.dashboard_time_within_statistics_expiration
      ) {
        // 应收应付账单统计
        this.getOrderHistCount();
      }
      if (
        this.funcView.dashboard_time_within_statistics_no_upload_chart
        || this.funcView.dashboard_time_within_statistics_no_upload_map
        || this.funcView.dashboard_time_within_statistics_no_upload_record
        || this.funcView.dashboard_time_within_statistics_incomplete_clean
        || this.funcView.dashboard_time_within_statistics_cliff
        || this.funcView.dashboard_time_within_statistics_collision
      ) {
        // 设备数据统计
        this.getDeviceHistCount();
      }
    },
    // 获取设备数据统计
    getDeviceHistCount() {
      this.$getJSON(apis.adminPortalDeviceWorkHistCount, {
        ...this.formSearch,
        days: this.formSearch.withinDays,
      }).then((res) => {
        this.deviceHistCount = res.data;
      });
    },
    // 获取设备数据统计
    getOrderHistCount() {
      this.$getJSON(apis.adminPortalOrderHistCount, {
        ...this.formSearch,
        days: this.formSearch.withinDays,
      }).then((res) => {
        this.orderHistCount = res.data;
      });
    },
    // 获取设备数据统计
    getOrderWorkHistCount() {
      this.$getJSON(apis.adminPortalDeviceHistCount, {
        ...this.formSearch,
        days: this.formSearch.utsideDays,
      }).then((res) => {
        // if (res.data) {
        //   this.$setFormatData(res.data, this.orderWorkHistCount);
        // }
        this.orderWorkHistCount = res.data || {};
      });
    },
    // 次数点开
    onUploadCount(type, data, tableCode) {
      this.isOpenCount = false;
      this.dialogVisible1 = true;
      this.dialogModel1 = {
        type,
        data: {
          ...data,
          agentCoName: this.formSearch.agentCoName,
          customerName: this.formSearch.customerName,
          afterServiceName: this.formSearch.afterServiceName,
          productCode: this.formSearch.productCode,
          locationName: this.formSearch.locationName,
        },
        tableCode,

        formSearch: null,
      };
    },
    onOpenBackCount(formSearch) {
      this.openFormSearchCount = formSearch;
      this.isOpenCount = true;
    },
    // 次数点开
    onQueryMenu() {
      this.dialogVisible2 = true;
      this.dialogModel2 = {
        title: this.$t('base_dashboard.kuai_jie_ru_kou'),
      };
    },

    // 机器业务趋势图
    getDeviceBizSheet() {
      this.$getJSON(apis.adminPortalTrendChartDeviceBiz, {
        ...this.formSearch,
      }).then((res) => {
        this.deviceBizSheetList = res.data;
      });
    },
    // 客户数量趋势图
    getCustomerSheet() {
      this.$getJSON(apis.adminPortalTrendChartCustomer, {
        ...this.formSearch,
      }).then((res) => {
        this.customerSheetList = res.data;
      });
    },
    // 客户数量趋势图
    getDeviceCleanSheet() {
      this.$getJSON(apis.adminPortalClean, {
        ...this.formSearch,
        // 天要特殊处理
        beginTime: this.formSearch.statisticsType !== 0 ? this.formSearch.beginTime : this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
        endTime: this.formSearch.statisticsType !== 0 ? this.formSearch.endTime : this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD'),
      }).then((res) => {
        this.deviceCleanSheetList = res.data;
      });
    },
    // 账单趋势图
    getBillSheet() {
      this.$getJSON(apis.billOrderTermTrendChart, {
        ...this.formSearch,
      }).then((res) => {
        this.billSheetList = res.data;
      });
    },
    // 工单趋势图
    getWorkOrderSheet() {
      this.$getJSON(apis.workOrderTrendChart, {
        ...this.formSearch,
      }).then((res) => {
        this.workOrderSheetList = res.data;
      });
    },
    // 故障排行
    getEventStatistics() {
      this.isLoadings = true;
      // const { beginTime, endTime, componentCodeVersion, ...searchData } = this.formSearch;

      this.$getDebounceJSON(apis.modemBatteryEventStatistics, {
        ...this.formSearch,
        productCode: this.formSearch.componentCode[0] || '',
        componentCode: this.formSearch.componentCode[1] || '',
        beginTime: undefined,
        endTime: undefined,
        componentCodeVersion: undefined,
        orderBy: this.orderBy,
        orderType: this.orderType,
        // beginTime: '2024-12-14 00:00:00',
        // endTime: '2025-04-24 00:00:00',
      }).then((res) => {
        this.isLoadings = false;
        this.eventStatisticsList = res.data;
      });
    },
    // 故障排行排序
    onSortChange({ prop, order }) {
      this.orderBy = prop;
      this.orderType = order;
      this.getEventStatistics();
    },
    // 机器总数 折线图点击
    onDeviceCount(row, dateTimes) {
      // dateTimes是折线图当天 如果不是就传整个范围
      this.isOpenFaultCount = false;
      this.dialogVisible3 = true;

      const maxdateTimes = [
        this.$momentWorld(moment(this.$getLocalTime()).subtract(30, 'day').format('YYYY-MM-DD 00:00:00')),
        this.$momentWorld(moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 23:59:59')),
      ];
      this.dialogModel3 = {
        title: `${row.productCode} ${row.componentName} ${row.hmiV4Code} ${row.eventCode} ${row.eventName}`,
        data: {
          ...row,
          dataType: this.formSearch.dataType,
          customerId: this.formSearch.customerId,
          agentCoId: this.formSearch.agentCoId,
          afterServiceId: this.formSearch.afterServiceId,
          locationId: this.formSearch.locationId,
          machineVersion: this.formSearch.machineVersion,
          dateTimes: dateTimes || maxdateTimes,
          maxdateTimes,
        },
      };
    },
    onOpenBackFaultCount(formSearch) {
      this.openFormSearchFaultCount = formSearch;
      this.isOpenFaultCount = true;
    },
    // 快捷入口
    getFavoriteQueryMenu() {
      this.$getJSON(apis.favoriteQueryMenu, {
        limit: true,
      }).then((res) => {
        this.favoriteMenuList = res.data || [];
      });
    },
    // 待办事项
    getWaitApproveStatistics() {
      this.$postJSON(apis.approveWaitApproveStatistics).then((res) => {
        this.waitApproveList = res.data;
      });
    },
    // 产品型号
    toggleSelection(productCode) {
      // const index = this.formSearch.productCode.indexOf(productCode);
      // if (index === -1) {
      //   // 如果未选中，添加到数组
      //   this.formSearch.productCode.push(productCode);
      //   this.formSearch.componentCodeVersion = [productCode, 'modem'];
      //   this.getProductComponentVersionCount();
      // } else {
      //   // 如果已选中，从数组中移除
      //   this.formSearch.productCode.splice(index, 1);
      //   this.formSearch.componentCodeVersion = ['Cobi18', 'modem'];
      // }
      // this.onTypeChange(true);

      // 单选模式：直接设置为当前选中的产品代码
      // 检查当前是否已选中该产品代码
      const isCurrentlySelected = this.formSearch.productCode.length === 1 && this.formSearch.productCode[0] === productCode;

      if (isCurrentlySelected) {
        // 如果已选中，则取消选中（清空数组）
        this.formSearch.productCode = [];
        // 当取消选中时，设置默认的componentCodeVersion
        this.formSearch.componentCodeVersion = ['Cobi18', 'modem'];
      } else {
        // 单选模式：设置为当前选中的产品代码
        this.formSearch.productCode = [productCode];
        this.formSearch.componentCodeVersion = [productCode, 'modem'];
        this.getProductComponentVersionCount();
      }
      this.onTypeChange(true);
    },
    isSelected(productCode) {
      return this.formSearch.productCode.includes(productCode); // 检查 productCode 是否已选中
    },
    clearTag(key, index) {
      this.formSearch[key].splice(index, 1);
      // this.formSearch[name].splice(index, 1);
      this.onTypeChange(true);
    },
    onClear() {
      this.formSearch.productCode = [];
      this.formSearch.productName = [];
      // 高级筛选
      this.formSearch.customerId = '';
      this.formSearch.customerName = '';
      this.formSearch.agentCoId = '';
      this.formSearch.agentCoName = '';
      this.formSearch.afterServiceId = '';
      this.formSearch.afterServiceName = '';
      this.formSearch.locationName = '';
      this.formSearch.locationId = '';
      // initValue会调用到
      this.onTypeChange();
    },
    // 获取季度
    getSeason: function (month) {
      if (month < 3) {
        return '01';
      } else if (month < 6) {
        return '02';
      } else if (month < 9) {
        return '03';
      } else if (month < 12) {
        return '04';
      }
      return true;
    },

    // 日期切换
    onTypeChange(onlyProduct = false) {
      if (onlyProduct) {
        // 产品型号搜索只需改
        if (this.funcView.dashboard_realtime_status) {
          //  机器状态
          this.getDeviceStatusCount();
        }
        if (this.funcView.dashboard_business_status) {
          // 机器业务
          this.getDeviceBizCount();
        }
        if (this.funcView.dashboard_work_order_pending || this.funcView.dashboard_work_order_processing) {
          // 工单
          this.getworkOrderStatistics();
        }
        if (this.funcView.dashboard_business_status_fault) {
          // 故障型号
          this.getFaultProductCount();
        }
        if (
          this.funcView.dashboard_financial_invoice_receipt
          || this.funcView.dashboard_financial_invoice_payment
          || this.funcView.dashboard_financial_receipt_timeliness
          || this.funcView.dashboard_financial_payment_timeliness
        ) {
          // 应收应付账单统计
          this.getbillOrderCount();
        }
        if (
          this.funcView.dashboard_within_statistics_rented
          || this.funcView.dashboard_time_within_statistics_trial
          || this.funcView.dashboard_time_within_statistics_sold
          || this.funcView.dashboard_time_within_statistics_expire
          || this.funcView.dashboard_time_within_statistics_expiration
        ) {
          // 应收应付账单统计
          this.getOrderHistCount();
        }
        if (
          this.funcView.dashboard_time_within_statistics_no_upload_chart
          || this.funcView.dashboard_time_within_statistics_no_upload_map
          || this.funcView.dashboard_time_within_statistics_no_upload_record
          || this.funcView.dashboard_time_within_statistics_incomplete_clean
          || this.funcView.dashboard_time_within_statistics_cliff
          || this.funcView.dashboard_time_within_statistics_collision
        ) {
          // 设备数据统计
          this.getDeviceHistCount();
        }
        if (this.funcView.dashboard_time_outside_statistics_unused || this.funcView.dashboard_time_outside_statistics_offline || this.funcView.dashboard_time_outside_statistics_fault) {
          // 设备数据统计
          this.getOrderWorkHistCount();
        }
        if (this.funcView.dashboard_trend_chart_machine_business) {
          // 机器业务趋势图
          this.getDeviceBizSheet();
        }
        if (this.funcView.dashboard_trend_chart_receivables) {
          // 账单趋势图
          this.getBillSheet();
        }
        if (this.funcView.dashboard_trend_chart_work_order) {
          // 工单趋势图
          this.getWorkOrderSheet();
        }
        if (this.funcView.dashboard_fault_ranking_table) {
          // 故障排行
          this.getEventStatistics();
        }
        return;
      }
      if (this.funcView.dashboard_realtime_status) {
        //  机器状态
        this.getDeviceStatusCount(true);
      }
      if (this.funcView.dashboard_business_status) {
        // 机器业务
        this.getDeviceBizCount();
      }
      if (this.funcView.dashboard_work_order_pending || this.funcView.dashboard_work_order_processing) {
        // 工单
        this.getworkOrderStatistics();
      }
      if (this.funcView.dashboard_business_status_fault) {
        // 故障型号
        this.getFaultProductCount();
      }
      if (this.funcView.dashboard_firmware_version) {
        // 固件版本
        this.getProductComponentVersionCount();
      }
      if (
        this.funcView.dashboard_financial_invoice_receipt
        || this.funcView.dashboard_financial_invoice_payment
        || this.funcView.dashboard_financial_receipt_timeliness
        || this.funcView.dashboard_financial_payment_timeliness
      ) {
        // 应收应付账单统计
        this.getbillOrderCount();
      }
      if (
        this.funcView.dashboard_within_statistics_rented
        || this.funcView.dashboard_time_within_statistics_trial
        || this.funcView.dashboard_time_within_statistics_sold
        || this.funcView.dashboard_time_within_statistics_expire
        || this.funcView.dashboard_time_within_statistics_expiration
      ) {
        // 应收应付账单统计
        this.getOrderHistCount();
      }
      if (
        this.funcView.dashboard_time_within_statistics_no_upload_chart
        || this.funcView.dashboard_time_within_statistics_no_upload_map
        || this.funcView.dashboard_time_within_statistics_no_upload_record
        || this.funcView.dashboard_time_within_statistics_incomplete_clean
        || this.funcView.dashboard_time_within_statistics_cliff
        || this.funcView.dashboard_time_within_statistics_collision
      ) {
        // 设备数据统计
        this.getDeviceHistCount();
      }
      if (this.funcView.dashboard_time_outside_statistics_unused || this.funcView.dashboard_time_outside_statistics_offline || this.funcView.dashboard_time_outside_statistics_fault) {
        // 设备数据统计
        this.getOrderWorkHistCount();
      }
      if (this.funcView.dashboard_trend_chart_machine_business) {
        // 机器业务趋势图
        this.getDeviceBizSheet();
      }
      if (this.funcView.dashboard_trend_chart_customer_count) {
        // 客户数量趋势图
        this.getCustomerSheet();
      }
      if (this.funcView.dashboard_trend_chart_machine_cleaning) {
        // 机器清洁趋势图
        this.getDeviceCleanSheet();
      }
      if (this.funcView.dashboard_trend_chart_receivables) {
        // 账单趋势图
        this.getBillSheet();
      }
      if (this.funcView.dashboard_trend_chart_work_order) {
        // 工单趋势图
        this.getWorkOrderSheet();
      }
      if (this.funcView.dashboard_fault_ranking_table) {
        // 故障排行
        this.getEventStatistics();
      }
      if (this.funcView.dashboard_quick_entry_menu) {
        // 快捷入口
        this.getFavoriteQueryMenu();
      }
      if (this.funcView.dashboard_quick_entry_todo) {
        // 待办事项
        this.getWaitApproveStatistics();
      }
    },
    // 报表日期切换
    onStatisticsTypeChange() {
      switch (this.formSearch.statisticsType) {
        case 1: // 年
          this.formSearch.beginTime = this.reportYearTime ? this.reportYearTime[0] : '';
          this.formSearch.endTime = this.reportYearTime ? this.reportYearTime[1] : '';
          this.onSheetChange();
          break;
        case 2: // 季
          this.formSearch.beginTime = this.reportSeasonTime ? this.reportSeasonTime[0] : '';
          this.formSearch.endTime = this.reportSeasonTime ? this.reportSeasonTime[1] : '';
          this.onSheetChange();
          break;
        case 3: // 月
          this.formSearch.beginTime = this.reportMonthTime ? this.reportMonthTime[0] : '';
          this.formSearch.endTime = this.reportMonthTime ? this.reportMonthTime[1] : '';
          this.onSheetChange();
          break;
        case 4: // 周
          this.formSearch.beginTime = this.reportWeekTime.length ? moment(this.reportWeekTime[0]).format('gggg-ww') : ''; // 转换时间因为现在是Date类型
          this.formSearch.endTime = this.reportWeekTime.length ? moment(this.reportWeekTime[1]).format('gggg-ww') : ''; // 转换时间因为现在是Date类型
          this.onSheetChange();
          break;
        default:
          this.formSearch.beginTime = this.dateTimes ? this.dateTimes[0] : '';
          this.formSearch.endTime = this.dateTimes ? this.dateTimes[1] : '';
          this.onSheetChange();
        // default: // 日
      }
    },
    onSheetChange() {
      if (this.funcView.dashboard_trend_chart_machine_business) {
        // 机器业务趋势图
        this.getDeviceBizSheet();
      }
      if (this.funcView.dashboard_trend_chart_customer_count) {
        // 客户数量趋势图
        this.getCustomerSheet();
      }
      if (this.funcView.dashboard_trend_chart_machine_cleaning) {
        // 机器清洁趋势图
        this.getDeviceCleanSheet();
      }
      if (this.funcView.dashboard_trend_chart_receivables) {
        // 账单趋势图
        this.getBillSheet();
      }
      if (this.funcView.dashboard_trend_chart_work_order) {
        // 工单趋势图
        this.getWorkOrderSheet();
      }
    },
    // 机器实时跳转
    onDeviceStatusCount(searchItem, timeKey, endTime) {
      // const machineState = [2, 3, 4];
      const searchItemCopy = { ...searchItem };
      searchItemCopy.formSearch = { ...this.formSearch, orgName: this.formSearch.customerName, locationName: this.formSearch.locationName };
      if (timeKey) {
        const startTime = this.$moment('2011-08-08').format('YYYY-MM-DD 00:00:00');
        // 本月头 月尾巴
        searchItemCopy.formSearch[timeKey] = [this.$momentWorld(startTime), endTime];
      }
      if (timeKey && timeKey === 'cleanTime') {
        this.jump('/redirect/device/mydevice', { formSearch: JSON.stringify(searchItemCopy.formSearch) }, null, true);
      }
      this.jump('/redirect/device/mydevice', { ...searchItemCopy, formSearch: JSON.stringify(searchItemCopy.formSearch) }, null, true);
    },
    // 故障
    onMalfunctionCount(endTime) {
      const startTime = this.$moment('2011-08-08').format('YYYY-MM-DD 00:00:00');
      // 本月头 月尾巴
      const reportDate = [this.$momentWorld(startTime), endTime];

      this.jump('/redirect/fault/manage', { tabIndex: '2', eventType: [23], formSearch: JSON.stringify({ ...this.formSearch, reportDate }) }, null, true);
    },
    // 锁机
    onDeviceLockCount(searchItem) {
      this.jump('/redirect/fault/lockCleanDevice', { ...searchItem, formSearch: JSON.stringify(this.formSearch) }, null, true);
    },
    // 机器业务跳转
    onDeviceBizCount(searchItem) {
      this.jump('/redirect/device/mybizdevice', { ...searchItem, formSearch: JSON.stringify(this.formSearch) }, null, true);
    },
    // 固件版本跳转
    onFwVersion(fwVersion) {
      const searchItemCopy = {};
      searchItemCopy.formSearch = JSON.stringify({
        type: 2,
        productCode: this.formSearch.componentCodeVersion[0],
        componentCode: this.formSearch.componentCodeVersion[1],
        fwVersion,
        fwVersionList: [fwVersion],
      });
      this.jump('/redirect/device/deviceComponent', searchItemCopy, null, true);
    },
    // 工单跳转
    onWorkOrderCount(searchItem) {
      this.jump('/redirect/workorder/my', { tabIndex: `${this.formSearch.workOrganType}` === '1' ? '0' : '1', ...searchItem, formSearch: JSON.stringify(this.formSearch) }, null, true);
    },
    onWorkflowType(row) {
      this.jump(
        '/redirect/examine/myApproval',
        {
          tabIndex: 1,
          workflowType: [row.workflowType],
        },
        null,
        true
      );
    },
    // 工单跳转
    onBillOrderCount(type, tab) {
      // 根据 type 判断 URL
      const url = type === 'receivable' ? '/redirect/receive/receiveOrder' : '/redirect/pay/payOrder';
      // 根据 tab 判断 tabIndex 和 search
      const searchItem = {};
      const finalTime = [this.$momentWorld(this.$moment().startOf('month').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(this.$moment().endOf('month').format('YYYY-MM-DD 23:59:59'))];
      const finalTimeNextMonth = [
        this.$momentWorld(this.$moment().startOf('month').subtract('month', -1).format('YYYY-MM-DD 00:00:00')),
        this.$momentWorld(this.$moment().endOf('month').subtract('month', -1).format('YYYY-MM-DD 23:59:59')),
      ];
      if (tab === 'thisMonthAmount') {
        searchItem.tabIndex = '3';
        searchItem.billTradeState = ['0', '1', '2', '6', '10'];
        // 本月头 月尾巴
        searchItem.formSearch = JSON.stringify({
          ...this.formSearch,
          initBillPaymentTime: [],
          billPaymentTime: [],
          finalTime,
        });
      } else if (tab === 'thisMonthPayment') {
        // 账单确认收款日期
        searchItem.tabIndex = '2';
        // 本月头 月尾巴
        searchItem.formSearch = JSON.stringify({
          ...this.formSearch,
          initBillPaymentTime: [],
          billPaymentTime: [],
          finalPaymentTime: finalTime,
        });
      } else if (tab === 'nextMonthAmount') {
        searchItem.tabIndex = '3';
        searchItem.billTradeState = ['0', '1', '2', '6', '10'];
        // 下月头 月尾巴
        searchItem.formSearch = JSON.stringify({
          ...this.formSearch,
          initBillPaymentTime: [],
          billPaymentTime: [],
          finalTime: finalTimeNextMonth,
          // initBillPaymentTime: initBillPaymentTimeNextMonth,
          // billPaymentTime: [this.$momentWorld(initBillPaymentTimeNextMonth[0]), this.$momentWorld(initBillPaymentTimeNextMonth[1])],
        });
      }
      this.jump(url, searchItem, null, true);
      // '/pay/payOrder';
    },
    // 租出
    onHistCountLease() {
      const rentalTime = [this.orderHistCount.pastStartTime, this.orderHistCount.pastEndTime];
      const searchItem = {
        tabIndex: '1',
        formSearch: JSON.stringify({
          ...this.formSearch,
          contractType: [40, 44, 20, 21, 22, 30, 31, 41, 42, 43, 50, 90, 100],
          effectiveDate: null,
          rentalTime,
        }),
      };
      this.jump('/redirect/contract/management', searchItem, null, true);
    },
    // 试用
    onHistCountTrial() {
      const rentalTime = [this.orderHistCount.pastStartTime, this.orderHistCount.pastEndTime];
      const searchItem = {
        tabIndex: '1',
        formSearch: JSON.stringify({
          ...this.formSearch,
          effectiveDate: null,
          rentalTime,
        }),
      };
      this.jump('/redirect/contract/trialOrder', searchItem, null, true);
    },
    // 已售
    onHistCountSale() {
      const rentalTime = [this.orderHistCount.pastStartTime, this.orderHistCount.pastEndTime];
      const searchItem = {
        tabIndex: '1',
        formSearch: JSON.stringify({
          effectiveDate: null,
          rentalTime,
          ...this.formSearch,
          partAName: this.formSearch.agentCoName,
          customerName: this.formSearch.customerName,
          afterServiceName: this.formSearch.afterServiceName,
          productCode: this.formSearch.productCode,
          locationName: this.formSearch.locationName,
        }),
      };
      this.jump('/redirect/contract/sales', searchItem, null, true);
    },
    // 将到期
    onHistCountExpiring() {
      // futureEndTime: '',
      // futureStartTime: '',
      // const initBillPaymentTimeNextMonth = [this.$momentLocal(this.orderHistCount.futureStartTime), this.$momentLocal(this.orderHistCount.futureEndTime)];

      const searchItem = {
        formSearch: JSON.stringify({
          // initBillPaymentTime: initBillPaymentTimeNextMonth,
          ...this.formSearch,
          csOrgName: this.formSearch.customerName,
          agentCoName: this.formSearch.jvOrgName,
          scOrgName: this.formSearch.afterServiceName,
          locationName: this.formSearch.locationName,
          backTime: [this.orderHistCount.futureStartTime, this.orderHistCount.futureEndTime],
        }),
      };
      this.jump('/redirect/device/mybizdevice', searchItem, null, true);
    },
    // 库存到期
    onStockExpired() {
      // futureEndTime: '',
      // futureStartTime: '',
      const nextBillDate = [this.orderHistCount.futureStartTime, this.orderHistCount.futureEndTime];
      const searchItem = {
        formSearch: JSON.stringify({
          nextBillDate,
          orgName: this.formSearch.afterServiceName,
          productCode: this.formSearch.productCode,
          partAName: this.formSearch.agentCoName,
          customerName: this.formSearch.customerName,
          afterServiceName: this.formSearch.afterServiceName,
          locationName: this.formSearch.locationName,
        }),
      };
      this.jump('/redirect/crmStock/manage', searchItem, null, true);
    },

    // 测试
    onFilter() {
      this.dialogModel.title = this.$t('base_dashboard.shai_xuan');
      this.dialogModel.data = this.formSearch;
      this.dialogVisible = true;
    },
    // 高级筛选
    onSearchSuccess(form) {
      this.$setFormatData(this.formSearch, form);
      this.onTypeChange();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
// @import './css/dashboard.scss';
.dashboard-bd {
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  height: 100%;

  // 筛选控件
  .el-radio-button {
    height: 32px;
    .el-radio-button__inner {
      height: 32px;
      line-height: 32px;
      padding: 0 16px;
      font-family: DIN 2014;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #4d4d4d;
      background: #fff;
      border: 1px solid #e6e6e6;
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #fff;
      background-color: #00a0d9;
      border: 0;
    }

    &:first-child .el-radio-button__inner {
      border-radius: 8px 0px 0px 8px;
    }

    &:last-child .el-radio-button__inner {
      border-radius: 0px 8px 8px 0px;
    }
  }
  .query-filter {
    padding: 0;
    .select-date {
      .el-input__prefix,
      .el-date-editor .el-range__icon {
        color: #00a0d9;
        font-size: 18px;
        margin-right: 8px;
      }
      input {
        font-weight: bold;
      }
      .el-input .el-input__inner {
        cursor: pointer;
        height: 48px;
        line-height: 48px;
        padding-left: 34px;
        font-weight: bold;
        color: #1a1a1a;
        text-align: center;
      }
      .el-input__icon :after {
        font-family: 'icon' !important;
        content: '\E7F8';
        font-size: 22px;
        color: #ffad00;
        margin-bottom: 2px;
      }
      // .el-range__close-icon.el-input__icon:after {
      //   font-family: 'icon' !important;
      //   content: '\E7F8';
      //   font-size: 22px;
      //   line-height: 42px;
      //   margin-right: 30px;
      //   color: ##FFAD00;
      // }
      .el-input__icon.el-range__icon.el-icon-date {
        color: #00a0d9;
        font-size: 18px;
        margin-top: 2px;
      }
      .el-input .el-input__inner {
        cursor: pointer;
        height: 48px;
        line-height: 48px;
        padding-left: 34px;
        font-weight: bold;
        color: #1a1a1a;
      }
    }
  }
  .dashboard-header {
    padding: 0 16px;
    width: 100%;
    height: 140px;
    position: relative;

    .title {
      padding-top: 19.5px;
      height: 70px;

      h3 {
        height: 25px;
        font-family: DIN 2014;
        font-size: 18px;
        font-weight: 700;
        line-height: 25px;
        text-align: left;
        color: rgba(13, 154, 224, 1);

        span {
          color: rgba(26, 26, 26, 1);
        }
      }

      p {
        margin-top: 4px;
        font-family: DIN 2014;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
        text-align: left;
        color: rgba(77, 77, 77, 1);
      }
    }

    .tabs {
      height: 40px;
      padding: 15px 0;

      .filter-form {
        display: flex;
        margin-right: 280px;

        .el-radio-button {
          height: 40px;
          .el-radio-button__inner {
            height: 40px;
            line-height: 40px;
            font-size: 14px;
          }
        }

        .filter-values {
          overflow: hidden;
          margin-top: 6px;
          margin-left: 24px;
          flex: 1;

          .label {
            float: left;
            margin-top: 5.5px;
            line-height: 30px;
            font-size: 12px;
            font-weight: 400;
            line-height: 16.8px;
            text-align: center;
            color: #4d4d4d;
          }

          .values {
            overflow: hidden;
            padding-left: 16px;
            margin-top: 0;

            .el-tag {
              border-radius: 10px;
              height: 28px;
              line-height: 28px;
              border: 1px solid rgba(0, 160, 217, 0.4);

              color: #1a1a1a;
              padding: 0 10px 0 16px;
              font-weight: bold;
              margin-right: 5px;
              background: #f8f8f8;

              .el-icon-close {
                font-size: 14px;
                font-weight: bold;
                color: #00a0d9 !important;
                transform: scale(1);
                height: 14px;
                width: 14px;
                line-height: 14px;
                margin-left: 8px;
              }
            }

            .el-button {
              padding-top: 8px !important;
              padding-bottom: 8px !important;
              border-width: 1px !important;
            }

            .clear {
              background: #f8f8f8;
              border-radius: 10px;
              height: 28px;
              line-height: 28px;
              border: 1px solid rgba(0, 160, 217, 0.4);
              text-align: center;
              color: #00a0d9;
              display: inline-block;

              font-size: 12px;
              padding: 0 14px;
              cursor: pointer;
            }
          }
        }

        .filter-btn {
          height: 40px;
          width: 40px;
          border-radius: 50%;
          border: 1px solid #e6e6e6;
          background: #ffffff;
          text-align: center;
          cursor: pointer;
          z-index: 10;

          i {
            display: inline-block;
            font-size: 14px;
            color: #4d4d4d;
            line-height: 40px;
          }
        }
      }
    }

    .bg-img {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      // z-index: 2;
      width: auto;
      height: 140px;
    }
  }

  .dashboard-wrap {
    padding: 0 16px;
    position: relative;
    overflow: hidden;
    flex: 1;
    /* 剩余高度自适应 */
    overflow-y: auto;
    /* 超出时显示垂直滚动条 */
    display: flex;

    margin-bottom: 24px;
    .dashboard-wrap-left {
      flex: 1;

      margin-bottom: 24px;
      margin-bottom: 100px;
      position: relative;
      max-width: 100%; /* 最大宽度 */
      // transition: width 0.28s;
      // -webkit-transition: width 0.28s;
    }

    .card {
      display: flex;
      background: #f8f8f8;
      margin-bottom: 10px;
      //       max-height: 422px;
      // overflow: hidden;
      .flex-box {
        display: flex;
        justify-content: space-between;
        .chart-select {
          display: flex;
          justify-self: flex-end;
          .select-box {
            &:first-child {
              margin-left: 0;
            }
            margin-left: 10px;
            .el-input__inner {
              border: 0 !important;
              padding: 0 18px 0 0 !important;
              color: #4d4d4d;
              font-family: DIN 2014;
              font-size: 12px;
              font-weight: 400;
              // line-height: 17px;
              // height: 17px;
              text-align: center;
            }
            // .el-input__icon{
            //   // line-height: 17px;
            // }
          }
        }
      }
      h4 {
        font-family: DIN 2014;
        font-size: 14px;
        font-weight: 700;
        line-height: 32px;
        text-align: left;
        color: #202945;
        margin-bottom: 16px;
        span {
          font-family: DIN 2014;
          font-size: 14px;
          font-weight: 400;
          line-height: 32px;
          margin-left: 10px;
          color: #4d4d4d;
        }
      }

      // 多行item
      .chart-info,
      .chart-status {
        display: flex; /* 使用 Flexbox 布局 */
        flex-wrap: wrap; /* 允许换行 */
        padding: 0 8px;
        .chart-info-item {
          cursor: pointer;
          width: calc(50% - 10px); /* 计算宽度为 50% 减去间距的一半 */
          margin-right: 20px; /* 右边和下边各 20px 的间距 */
          box-sizing: border-box; /* 包含内边距和边框在内的宽度计算 */
          height: 23px;
          display: flex;
          align-items: center; /* 垂直居中对齐 */
          i {
            display: inline-block;
            height: 12px;
            width: 12px;
            border-radius: 2px;
            margin-top: 1.5px;
          }
          .line {
            flex: 1;
            margin-left: 16px;
            height: 23px;
            line-height: 23px;
            font-family: DIN 2014;
            font-size: 12px;
            font-weight: 400;
            color: #1a1a1a;
            display: flex;
            justify-content: space-between;
            &:not(.line-t):hover {
              font-size: 14px;
              font-family: DIN 2014;
              font-weight: 700;
              background: #f5f5f5;
              .num {
                color: #00a0d9;
                text-decoration: underline #00a0d9 solid;
              }
            }
            &.line-t {
              cursor: initial;
            }
            .name {
              text-align: left;
            }
            .num {
              color: #1a1a1a;
              text-align: right;
            }
          }

          &:nth-child(2n) {
            margin-right: 0; /* 每行的第二个元素右边距设为 0，避免多余的右边距 */
          }
        }
      }
      .pie {
        flex: 1;
        border-radius: 8px;
        margin-right: 10px;
        background-color: #fff;
        padding: 16px;
        &:nth-child(even) {
          margin-right: 0;
        }
        .pie-item {
          display: flex; /* 设置为 Flexbox 布局 */
          // justify-content: center; /* 水平居中对齐 */
          // align-items: center; /* 垂直居中对齐 */
          .chart-pie {
            width: 100px;
            height: 100px;
            margin: 16px auto;
          }

          .pie-chart-left,
          .pie-chart-right {
            flex: 1;
            padding: 12px 16px 28px;
            border: 1px solid #f0f0f0;
            border-radius: 8px;
            .title {
              height: 32px;
              line-height: 32px;
              font-family: DIN 2014;
              font-size: 12px;
              font-weight: 700;
              color: #4d4d4d;
            }

            .chart-status {
              &::before {
                content: '';
                display: block;
                height: 1px;
                background: #f5f5f5;
                margin: 11.5px 0;
                padding: 0 8px;
                width: 100%;
              }
              .line {
                margin-left: 28px;
              }
            }
            .chart-status {
              .chart-info-item {
                // width: 100%;
                margin-right: 20px;
                &:nth-child(2n) {
                  margin-right: 0; /* 每行的第二个元素右边距设为 0，避免多余的右边距 */
                }
              }
            }
          }

          .pie-chart-right {
            margin-left: 10px; /* 只为第二个元素设置左边距 */
            flex: 1;
          }
        }
      }

      .device {
        width: 347px;
        border-radius: 8px;
        background-color: #fff;
        padding: 16px;

        .model-info {
          display: flex; /* 使用 Flexbox 布局 */
          flex-wrap: wrap; /* 允许换行 */
          width: 100%;
          height: 342px;
          overflow: hidden;
          overflow-y: scroll;
          // &:hover{
          //   overflow-y: auto;
          // }
          .model-info-item {
            cursor: pointer;
            width: calc(33.33% - 3.34px); /* 每个 li 占据 1/3 的宽度，减去间距的一半 */
            margin: 0 5px 5px 0; /* 右边和下边各 5px 的间距 */
            box-sizing: border-box; /* 包含内边距和边框在内的宽度计算 */
            height: 90px;
            border-radius: 8px;
            position: relative;
            border: 1px solid #f0f0f0;
            padding-bottom: 7px;
            &:hover {
              border-color: rgba(0, 160, 217, 0.4);
              .num {
                background-color: rgba(0, 160, 217, 0.4);
              }
            }
            &:active,
            &.selected {
              border-color: rgba(0, 160, 217, 1);
              .num {
                background-color: rgba(0, 160, 217, 1);
                color: #ffffff;
              }
              .model {
                color: #00a0d9;
              }
            }
            &:nth-child(3n) {
              margin-right: 0; /* 每行的第三个元素右边距设为 0，避免多余的右边距 */
            }
            .num {
              position: absolute;
              top: 0;
              right: 0;
              display: inline-block;
              width: 38px;
              height: 24px;
              border-radius: 0px 8px 0px 100px;
              background: #f5f5f5;
              text-align: center;
              color: #1a1a1a;
              font-family: DIN 2014;
              font-size: 12px;
              font-weight: 400;
              text-align: center;
              line-height: 24px;
            }
            .img {
              display: block;
              margin: 15px auto 0;
              height: 44px;
              width: auto;
            }
            .model {
              height: 24px;
              line-height: 24px;
              color: #1a1a1a;
              font-family: DIN 2014;
              font-size: 12px;
              font-weight: 700;
              text-align: center;
            }
          }
        }
      }
    }

    .card-order,
    .financial-order {
      display: flex;
      .pie-chart-left,
      .pie-chart-right {
        padding-bottom: 12px !important;
      }
      .pie-ovh {
        height: 286px;
        display: flex;
        flex-direction: column;
        // overflow: hidden;
        .chart-info-ovh {
          flex: 1;
          // height: 196px;
          // overflow: hidden;
          height: auto;
          background-color: #fff;
          overflow-y: auto;
          overflow-x: clip;
          // &:hover{
          //   height: auto;
          //   background-color: #fff;
          //   overflow-y: auto;
          // }
        }
      }

      .chart-info {
        display: block;
        .chart-info-item {
          width: 100%;
        }
      }
    }
    .financial-order {
      .chart-status {
        .chart-info-item {
          width: 100%;
          margin-right: 0px !important;
        }
      }
      .pie {
        margin-right: 0 !important;
      }
      .pie-item {
        display: flex; /* 使用 Flexbox 布局 */
        flex-wrap: wrap; /* 允许换行 */
        width: 100%;
        .pie-chart-left {
          width: 25%; /* 每个 li 占据 1/3 的宽度，减去间距的一半 */
          margin-right: 10px;
        }
        .pie-chart-right {
          width: 25%; /* 每个 li 占据 1/3 的宽度，减去间距的一半 */
          margin: 0px !important;
        }
        .financial-chart-pie {
          margin-top: 53.5px !important;
        }
      }
    }
    .count-device,
    .line-chart {
      .el-radio-button {
        height: 32px;
      }
      .pie {
        margin-right: 0 !important;
      }
      .header {
        display: flex;
        justify-content: space-between;
        p {
          margin-left: auto;
          margin-right: 24px;
          color: #1a1a1a;
          font-size: 14px;
          line-height: 32px;
          font-weight: 400;
        }
      }
      .pie-row {
        height: 75px;

        &:last-child {
          margin-bottom: 0;
        }
        .grid-content {
          height: 75px;
          padding: 17px 16px 11px 16px;
          border-radius: 8px;
          border: 1px solid #f0f0f0;
          margin-bottom: 10px;
          h6 {
            font-family: DIN 2014;
            font-size: 12px;
            font-weight: 400;
            height: 17px;
            line-height: 17px;
            margin-bottom: 5px;
            color: #4d4d4d;
            display: flex;
            align-items: center;
            i {
              line-height: 17px;
              margin-left: 5px;
              color: #b3b3b3;
              font-size: 16px;
            }
          }
          p {
            font-family: DIN 2014;
            font-size: 18px;
            font-weight: 700;
            line-height: 25px;
            color: #1a1a1a;
            cursor: pointer;
          }
        }
      }
    }
    .line-chart {
      .line-chart-wrap {
        .line-chart-list {
          display: flex; /* 使用 Flexbox 布局 */
          flex-wrap: wrap; /* 允许换行 */

          .line-chart-item {
            width: calc(50% - 5px); /* 计算宽度为 50% 减去间距的一半 */
            margin-right: 10px; /* 右边和下边各 20px 的间距 */
            margin-top: 10px;
            box-sizing: border-box; /* 包含内边距和边框在内的宽度计算 */
            height: 292px;
            &:nth-child(2n) {
              margin-right: 0;
            }
          }
        }
        .line-chart-item {
          padding: 12px 16px 12px 16px;
          border-radius: 8px;
          border: 1px solid #f0f0f0;
          margin-top: 10px;
          &.overall {
            width: 100%;
            height: 300px;
          }
        }
      }
      // 季度组件
      .el-mark {
        position: absolute;
        background: rgba(0, 0, 0, 0);
        z-index: 999;
      }
      .quarter-picker .el-input__prefix .icon-calendar {
        line-height: 32px;
        font-size: 14px;
        color: #c0c4cc;
      }
      .box-card {
        width: 322px;
        padding: 0 3px 20px;
        margin-top: 10px;
        position: absolute;
        top: 20px;
        background: #fff;
        border-radius: 8px;
        z-index: 9999;
      }
    }

    .fault-table {
      display: block;
      padding: 16px;
      background-color: #fff;

      .header {
        display: flex;
        justify-content: flex-end;
        h4 {
          margin-right: auto;
        }
      }
    }
    // 表格
    .table-event {
      width: 100%;
      // 表头
      .table-head {
        height: 40px;
        line-height: 40px;
        display: flex;
        background-color: #fff;
        align-items: center;
        li {
          // flex: 1;
          line-height: 18px;
          flex: 0 0 70px;
          // padding-left: 10px;
          // text-align: center;
          color: #4d4d4d;
          box-sizing: border-box;
          margin-right: 24px;
          // overflow: hidden; /* 确保超出的文本被裁剪 */
          word-wrap: break-word; /* 允许在单词内换行 */
          overflow-wrap: break-word; /* 同上，现代浏览器推荐使用 */
          white-space: normal; /* 允许换行 */

          &:last-child {
            margin-right: 0;
          }
          span {
            font-weight: bold;
            font-size: 12px;
            color: #4d4d4d;
          }
          &.code,
          &.label {
            flex: 2;
            .num-th {
              padding-left: 60px;
            }
          }
          &.code {
            flex: 0 0 130px;
          }
          &.sheet {
            flex: 0 0 300px; /* 不缩小，不增长，宽度为 300px */
            display: flex;
            // flex-direction:row ;
            align-items: center;
            span {
              font-family: DIN 2014;
              font-size: 12px;
              font-weight: 400;
              text-align: left;
              color: #1a1a1a;
              margin: 0 10px;
            }
            i {
              display: block;
              height: 12px;
              width: 12px;
              background: #00a0d9;
              border-radius: 2px;
            }
            .bar {
              height: 2px;
              background: #93da49;
              border-radius: 0px;
            }
          }
        }
      }
      // 内容
      .table-body {
        // height: 70px;
        // line-height: 70px;
        // align-content: center;
        .content {
          cursor: pointer;
          width: 100%;
          height: 70px;
          line-height: 70px;
          color: #4d4d4d;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          background-color: #fff;
          border-top: 1px solid #f5f5f5;
          // padding-right: 24px;
          li {
            box-sizing: border-box;
            margin-right: 24px;
            flex: 0 0 70px;
            color: #4d4d4d;
            overflow: hidden; /* 确保超出的文本被裁剪 */
            white-space: nowrap; /* 确保文本在一行内显示 */
            text-overflow: ellipsis; /* 超出的文本显示为省略号 */
            &:last-child {
              margin-right: 0;
            }

            // text-align: center;
            &.code,
            &.label {
              flex: 2;
              color: #1a1a1a;
              span {
                color: #1a1a1a;
              }
            }
            &.code {
              flex: 0 0 130px;
            }
            &.num {
              color: #1a1a1a;
              span {
                color: #1a1a1a;
              }
            }
            &.num-device {
              &:hover {
                span {
                  color: #00a0d9;
                  text-decoration: underline #00a0d9 solid;
                }
              }
            }
            &.sheet {
              flex: 0 0 300px; /* 不缩小，不增长，宽度为 300px */
            }
            .num-info {
              display: flex;
              color: #1a1a1a;
              span {
                margin-left: 16px;
                display: inline-block;
                width: 24px;
              }
              p {
                margin-left: 18px;
                font-family: DIN 2014;
                font-size: 12px;
                font-weight: 700;
              }
            }
            .text {
              align-self: center;
              display: flex;
              // align-items: center;
              flex-direction: column;
              p {
                font-family: DIN 2014;
                font-size: 12px;
                line-height: 14px;
                color: #4d4d4d;
                &:first-child {
                  color: #1a1a1a;
                  margin-bottom: 2px;
                }
              }
            }
            span {
              color: #4d4d4d;
              font-size: 12px;
              font-family: DIN 2014;
              font-weight: 400;
              line-height: 14px;
              // text-align: center;
              // display: inline-block;
            }

            // .fault-sheet{
            //   height: 40px;
            //   width: 100%;
            //   margin-right: 16px;
            // }
          }
        }
      }
      // 无数据
      .no-data {
        margin-top: 24px;
        height: 130px;
        text-align: center;
        line-height: 130px;
        font-size: 16px;
        color: #818181;
        background: #ffffff;
        border-radius: 16px;
      }
      // 列占比
    }
    .table-footer {
      margin-top: 16px;
    }

    // 右边边栏
    .dashboard-wrap-right {
      margin-left: 24px;
      width: 240px;
      opacity: 1;
      transition: width 0.3s ease, opacity 0.3s ease;
      &.hide {
        width: 0;
        opacity: 0;
        pointer-events: none;
      }
      .nav {
        width: 100%;
        border-radius: 8px;
        background-color: #fff;
        padding: 16px;
        margin-bottom: 10px;
      }
      .nav-entry,
      .nav-pending {
        .header {
          height: 20px;
          line-height: 20px;
          display: flex;
          // justify-content: space-between;
          align-items: center;
          h4 {
            font-family: DIN 2014;
            font-size: 14px;
            font-weight: 700;
            color: #1a1a1a;
            margin-left: 8px;
          }
          i {
            font-size: 16px;
            color: #93da49;
            &:last-child {
              color: #00a0d9;
              margin-left: auto;
              cursor: pointer;
            }
          }
        }
        .entry-list {
          margin-top: 16px;

          li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 32px;
            line-height: 32px;
            padding-left: 6px;
            cursor: pointer;
            span {
              font-family: DIN 2014;
              font-size: 12px;
              font-weight: 400;
              color: #1a1a1a;
              /* 强制文本单行显示 */
              white-space: nowrap;
              /* 溢出隐藏 */
              overflow: hidden;
              /* 显示省略号 */
              text-overflow: ellipsis;
            }
            i {
              font-size: 14px;
              color: #818181;
            }
          }
        }
      }
      .nav-pending {
        .header {
          i {
            color: #00a0d9;
          }
        }
        .entry-list {
          li {
            display: flex;
            align-items: center;
            // justify-content: space-between;
            // .type {
            // }
            .num {
              margin: 0 4px 0 auto;
              color: #4d4d4d;
            }
            i {
              font-size: 14px;
              color: #818181;
            }
          }
        }
      }
    }
  }
  .icon-full {
    cursor: pointer;
    position: fixed;
    z-index: 99;
    top: 65%;
    right: 273px;
    transform: translateY(-50%); /* 使其中心与容器中心对齐 */
    font-size: 12px;
    color: #1a1a1a;
  }

  .icon-full-right {
    right: 11px;
  }
}
@media (max-width: 1600px) {
  /* 当屏幕宽度小于 1600px 时应用的样式 */
  .dashboard-bd {
    min-width: 1600px;
    .icon-full {
      position: absolute;
      left: 1314px;
    }
    .icon-ful-right {
      position: fixed;
      left: inherit;
    }
  }
}
</style>
